window.SCS_CART_02_CONFIG = window.SCS_CART_02_CONFIG || {};
  window.SCS_CART_02_CONFIG = {
  ...window.SCS_CART_02_CONFIG,
  giftBundles: [
    {
      variantIds: [53961500590372, 53961466773796],   // every one of these must be present as a gift line item
      title: "Magnetic Stone Air Freshener",
      image: "https://cdn.shopify.com/s/files/1/0732/5909/0212/files/stone-clip.jpg?v=1778884816",
      price: 20                    // dollars — shown as the struck-through "value", item stays FREE
    },
    {
      variantIds: [49006990590244, 54049441939748],   // every one of these must be present as a gift line item
      title: "Interior Protection Kit",
      image: "https://cdn.shopify.com/s/files/1/0732/5909/0212/files/protection-kit_cd7bac9c-41a1-4d2c-a44e-e99775e19a57.jpg?v=1779556475",
      price: 42                    // dollars — shown as the struck-through "value", item stays FREE
    },
    // add more rule objects for more bundles
  ]
};

(() => {
    const ROOT_ID = "SCS_CART_02";
    const AUGUST_OFFER_PATH = "/pages/august-offer-2026";

    function isAugustOfferPage() {
      return String(window.location.pathname || "").toLowerCase().includes(AUGUST_OFFER_PATH);
    }

    function applyAugustOfferUpsellHide() {
      const hide = isAugustOfferPage();
      if (root) root.classList.toggle("is-august-offer", hide);
      if (!hide) return;
      document.querySelectorAll(".SCS_CART_02__cart_upsell_host").forEach((el) => {
        el.style.display = "none";
        el.hidden = true;
      });
    }
    if (window.__SCS_CART_02_INITIALIZED__ && document.getElementById(ROOT_ID)) return;
    if (window.__SCS_CART_02_INITIALIZED__ && !document.getElementById(ROOT_ID)) {
      window.__SCS_CART_02_INITIALIZED__ = false;
    }
  
    let root = null;
    let refs = null;
    let bootstrapping = true;
    let closingCart = false;
  
    function ensureMount() {
      if (!document.body) return null;
      let mount = document.getElementById(ROOT_ID);
      if (!mount) {
        mount = document.createElement("div");
        mount.id = ROOT_ID;
        mount.className = "SCS_CART_02 is-closed SCS_CART_02__mount";
        mount.innerHTML = `
          <div class="SCS_CART_02__overlay" data-action="overlay-close"></div>
          <div class="SCS_CART_02__drawer" role="dialog" aria-modal="true" aria-label="Your cart">
            <header class="SCS_CART_02__drawer-header">
              <h1 id="SCS_CART_02_title">Your Cart</h1>
              <button type="button" class="SCS_CART_02__icon-btn" data-action="close-cart" aria-label="Close cart">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M17.7972 0.381189C17.917 0.261385 18.0592 0.166351 18.2158 0.101513C18.3724 0.0366761 18.5402 0.00330516 18.7096 0.00330516C18.8791 0.00330516 19.0469 0.0366761 19.2034 0.101513C19.36 0.166351 19.5022 0.261385 19.6221 0.381189C19.7419 0.500992 19.8369 0.64322 19.9018 0.799751C19.9666 0.956282 20 1.12405 20 1.29348C20 1.46291 19.9666 1.63068 19.9018 1.78721C19.8369 1.94374 19.7419 2.08597 19.6221 2.20577L11.8281 10.0007L19.6221 17.7956L19.7884 17.9978C19.9509 18.2462 20.023 18.5429 19.9925 18.8382C19.962 19.1334 19.8308 19.4091 19.6209 19.619C19.411 19.8289 19.1352 19.9601 18.8399 19.9906C18.5446 20.0211 18.2478 19.949 17.9994 19.7865L17.7972 19.6202L10.001 11.8253L2.20478 19.6224C2.08481 19.7422 1.94241 19.8373 1.78572 19.902C1.62902 19.9668 1.4611 20.0001 1.29154 20C1.12198 19.9999 0.954102 19.9664 0.797489 19.9014C0.640875 19.8365 0.498595 19.7413 0.378772 19.6213C0.258949 19.5014 0.163929 19.359 0.0991373 19.2023C0.0343458 19.0457 0.00105187 18.8778 0.00115622 18.7082C0.00126056 18.5387 0.0347611 18.3709 0.0997454 18.2143C0.16473 18.0577 0.259925 17.9154 0.379896 17.7956L8.17609 10.0007L0.377648 2.20577L0.213589 2.00354C0.0497468 1.75523 -0.0233778 1.458 0.00656103 1.16203C0.0364999 0.866059 0.167668 0.589486 0.377919 0.379005C0.588171 0.168524 0.864625 0.0370297 1.1606 0.00672421C1.45658 -0.0235813 1.75396 0.0491583 2.00251 0.212662L2.20478 0.381189L10.001 8.17386L17.7972 0.381189Z" fill="black"/>
                </svg>
              </button>
            </header>
            <div class="SCS_CART_02__drawer-content">
              <div class="SCS_CART_02__refresh-overlay" aria-hidden="true">
                <span class="SCS_CART_02__refresh-spinner" aria-hidden="true"></span>
              </div>
              <div id="SCS_CART_02_body" class="SCS_CART_02__drawer-body SCS_CART_02__empty-block"></div>
              <footer id="SCS_CART_02_footer" class="SCS_CART_02__drawer-footer SCS_CART_02__empty-block"></footer>
            </div>
          </div>
        `;
        document.body.appendChild(mount);
      }
      return mount;
    }
  
    let refreshHold = 0;
    let activeCartFetch = null;
    let rebuyFetchPromise = null;
    let rebuyCartSignature = "";
    let rebuyLoadGeneration = 0;
    let rebuyCartRefreshTimer = null;
    let dealFetchPromise = null;
    let blockedRemovalTimer = null;
    let blockedRemovalInProgress = false;
    let lastRenderKey = "";
    const variantCompareCache = new Map();
    let lineItemCompareEnrichGen = 0;
  
    const state = {
      cart: null,
      loading: false,
      refreshing: false,
      silentRefreshing: false,
      deal: {
        fit: "car",
        prices: { car: 10900, truck: 11900 },
        compareAts: { car: 17900, truck: 18900 },
        variantIds: { car: null, truck: null },
        product: null,
      },
      upsellFits: {},
      recommendations: [],
      rebuyLoading: false,
    };
  
    const cfg = window.SCS_CART_02_CONFIG || {};
    const REBUY_UPSELL_WIDGET_ID = String(cfg.rebuyWidgetId || 105665);
    const REBUY_DEAL_WIDGET_ID = String(cfg.rebuyDealWidgetId || 295798);
    const DEAL_SNAPSHOT_KEY = "SCS_CART_02_deal_snapshot";
    const BLOCKED_CART_PRODUCT_IDS = (Array.isArray(cfg.blockedProductIds)
      ? cfg.blockedProductIds
      : [9971677495588]
    ).map(Number);
    const FREE_SHIPPING_THRESHOLD = Number(cfg.freeShippingThreshold ?? 2000);
    const SHOPIFY_FILES = "https://cdn.shopify.com/s/files/1/0732/5909/0212/files";
    const BADGE_DESKTOP = `${SHOPIFY_FILES}/Security_Badges_Container.png?v=1782454010`;
    const BADGE_MOBILE = `${SHOPIFY_FILES}/Security_Badges_Container_1.png?v=1782454067`;
    const ICON_SVG = {
      minus: `
  <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="10" height="2" rx="1" fill="black"/>
  </svg>
  `,
      trash: `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display:block" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M7.6 3.8H11.4C11.4 3.29609 11.1998 2.81282 10.8435 2.4565C10.4872 2.10018 10.0039 1.9 9.5 1.9C8.99609 1.9 8.51282 2.10018 8.1565 2.4565C7.80018 2.81282 7.6 3.29609 7.6 3.8ZM5.7 3.8C5.7 2.79218 6.10036 1.82563 6.81299 1.11299C7.52563 0.400356 8.49218 0 9.5 0C10.5078 0 11.4744 0.400356 12.187 1.11299C12.8996 1.82563 13.3 2.79218 13.3 3.8H18.05C18.302 3.8 18.5436 3.90009 18.7218 4.07825C18.8999 4.25641 19 4.49804 19 4.75C19 5.00196 18.8999 5.24359 18.7218 5.42175C18.5436 5.59991 18.302 5.7 18.05 5.7H17.2121L16.3704 15.523C16.2895 16.4715 15.8555 17.3552 15.1543 17.999C14.453 18.6429 13.5357 19.0001 12.5837 19H6.4163C5.46431 19.0001 4.54696 18.6429 3.84574 17.999C3.14452 17.3552 2.71052 16.4715 2.6296 15.523L1.7879 5.7H0.95C0.698044 5.7 0.456408 5.59991 0.278249 5.42175C0.100089 5.24359 0 5.00196 0 4.75C0 4.49804 0.100089 4.25641 0.278249 4.07825C0.456408 3.90009 0.698044 3.8 0.95 3.8H5.7ZM12.35 9.5C12.35 9.24804 12.2499 9.00641 12.0718 8.82825C11.8936 8.65009 11.652 8.55 11.4 8.55C11.148 8.55 10.9064 8.65009 10.7282 8.82825C10.5501 9.00641 10.45 9.24804 10.45 9.5V13.3C10.45 13.552 10.5501 13.7936 10.7282 13.9718C10.9064 14.1499 11.148 14.25 11.4 14.25C11.652 14.25 11.8936 14.1499 12.0718 13.9718C12.2499 13.7936 12.35 13.552 12.35 13.3V9.5ZM7.6 8.55C7.85196 8.55 8.09359 8.65009 8.27175 8.82825C8.44991 9.00641 8.55 9.24804 8.55 9.5V13.3C8.55 13.552 8.44991 13.7936 8.27175 13.9718C8.09359 14.1499 7.85196 14.25 7.6 14.25C7.34804 14.25 7.10641 14.1499 6.92825 13.9718C6.75009 13.7936 6.65 13.552 6.65 13.3V9.5C6.65 9.24804 6.75009 9.00641 6.92825 8.82825C7.10641 8.65009 7.34804 8.55 7.6 8.55ZM4.522 15.3615C4.56247 15.8359 4.77961 16.2779 5.13042 16.5998C5.48123 16.9218 5.94014 17.1003 6.4163 17.1H12.5837C13.0595 17.0998 13.518 16.9211 13.8684 16.5992C14.2188 16.2773 14.4357 15.8356 14.4761 15.3615L15.3045 5.7H3.6955L4.522 15.3615Z" fill="#A2A2A2"/></svg>`,
      plus: `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display:block" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect width="19" height="19" rx="3" fill="#F0F0F0"/><path d="M14.2857 10.7143H10.7143V14.2857C10.7143 14.4752 10.639 14.6568 10.5051 14.7908C10.3711 14.9247 10.1894 15 10 15C9.81056 15 9.62888 14.9247 9.49492 14.7908C9.36097 14.6568 9.28571 14.4752 9.28571 14.2857V10.7143H5.71429C5.52485 10.7143 5.34316 10.639 5.20921 10.5051C5.07526 10.3711 5 10.1894 5 10C5 9.81056 5.07526 9.62888 5.20921 9.49492C5.34316 9.36097 5.52485 9.28571 5.71429 9.28571H9.28571V5.71429C9.28571 5.52485 9.36097 5.34316 9.49492 5.20921C9.62888 5.07525 9.81056 5 10 5C10.1894 5 10.3711 5.07525 10.5051 5.20921C10.639 5.34316 10.7143 5.52485 10.7143 5.71429V9.28571H14.2857C14.4752 9.28571 14.6568 9.36097 14.7908 9.49492C14.9247 9.62888 15 9.81056 15 10C15 10.1894 14.9247 10.3711 14.7908 10.5051C14.6568 10.639 14.4752 10.7143 14.2857 10.7143Z" fill="#000"/></svg>`,
      edit: `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display:block" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M13.06 1.94a1.5 1.5 0 0 1 2.12 0l1.88 1.88a1.5 1.5 0 0 1 0 2.12L7.24 15.76l-4.4.94.94-4.4L13.06 1.94Z" stroke="#A2A2A2" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.5 3.5 15.5 7.5" stroke="#A2A2A2" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    };
  
    function toMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents);
      }
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      }).format((cents || 0) / 100);
    }
  
    function toBadgeMoney(cents) {
      return toMoney(cents).replace(/\.00$/, "");
    }
  
    function getLineItemUnitSaleCents(item, options = {}) {
      const upsell = getPremiumCartUpsellDisplayPricing(item, options);
      if (upsell?.saleCents != null) return upsell.saleCents;
      return Number(item.final_price ?? item.discounted_price ?? item.price ?? 0);
    }
  
    function getDealVariantCompareFromState(variantId) {
      const id = Number(variantId);
      if (!id) return 0;
  
      const ids = getDealVariantIds();
      if (Number(ids.car) === id && state.deal.compareAts.car) {
        return Number(state.deal.compareAts.car);
      }
      if (Number(ids.truck) === id && state.deal.compareAts.truck) {
        return Number(state.deal.compareAts.truck);
      }
  
      const fromProduct = state.deal.product?.variants?.find((variant) => Number(variant.id) === id);
      if (fromProduct?.compare_at_price) return Number(fromProduct.compare_at_price);
  
      const stored = getStoredDealSnapshot();
      const fromStored = stored?.product?.variants?.find((variant) => Number(variant.id) === id);
      if (fromStored?.compare_at_price) return Number(fromStored.compare_at_price);
  
      return 0;
    }
  
    function getCartDrawerNewConfig() {
      const cfg = window.SCS_CART_DRAWER_NEW;
      return cfg && typeof cfg === "object" ? cfg : null;
    }

    function isPremiumCartUpsellActive() {
      const cfg = getCartDrawerNewConfig();
      return Boolean(cfg?.enabled && Array.isArray(cfg.products) && cfg.products.length);
    }

    function getCartUpsellLineProp(item, key) {
      const props = item?.properties || {};
      if (props[key] != null && props[key] !== "") return String(props[key]);
      const lower = key.toLowerCase();
      for (const [k, v] of Object.entries(props)) {
        if (k.toLowerCase() === lower && v != null && v !== "") return String(v);
      }
      return "";
    }

    function isPremiumCartUpsellLine(item) {
      return getCartUpsellLineProp(item, "_cart_upsell").toLowerCase() === "true";
    }

    function findPremiumUpsellProduct(item) {
      const cfg = getCartDrawerNewConfig();
      if (!cfg?.products?.length) return null;
      const vid = String(item?.variant_id ?? item?.id ?? "");
      return cfg.products.find((p) => String(p.variantId) === vid) || null;
    }

    function getLineSaleCents(item) {
      return Number(item?.final_price ?? item?.discounted_price ?? item?.price ?? 0);
    }

    function getPremiumCartUpsellDisplayPricing(item, options = {}) {
      if (!isPremiumCartUpsellActive() || !isPremiumCartUpsellLine(item)) return null;
      if (!cartHasLuxurySeatCover()) return null;
      const product = findPremiumUpsellProduct(item);
      if (!product || product.showInUpsell === false) return null;

      const cfg = getCartDrawerNewConfig();
      const saleCents = getLineSaleCents(item);
      const msrpCents =
        Number(product.msrpCents) ||
        Number(item.original_price) ||
        Number(item.price) ||
        0;
      const compareCents = msrpCents > saleCents ? msrpCents : 0;

      const isIndividual = hasIndividualUpsellProp(item);
      if (
        isIndividual &&
        !options.forceBundle &&
        cfg?.showIndividualDiscountLabel !== false
      ) {
        const label = String(cfg.individualDiscountLabel || "").trim() || "25% OFF";
        return {
          saleCents,
          compareCents,
          discountLabel: label,
          offerMode: "individual",
        };
      }

      const bundleComplete = getPremiumUpsellBundleState().active;
      const treatAsBundle =
        options.forceBundle ||
        isPremiumBundleLine(item, product) ||
        (bundleComplete && isPremiumCartUpsellLine(item));
      if (!treatAsBundle) return null;
      if (!options.forceBundle && !bundleComplete) return null;

      return {
        saleCents,
        compareCents,
        discountLabel: "Bundle price",
        offerMode: "bundle",
      };
    }

    function hasPremiumWidgetId(item) {
      return Boolean(getCartUpsellLineProp(item, "_widget_id"));
    }

    function hasBundleUpsellProp(item) {
      return getCartUpsellLineProp(item, "_bundle_upsell").toLowerCase() === "true";
    }

    function hasIndividualUpsellProp(item) {
      return getCartUpsellLineProp(item, "_individual_upsell").toLowerCase() === "true";
    }

    function isPremiumBundleLine(item, product) {
      if (!item) return false;
      // Explicit bundle marker from CART-01 property sync.
      if (hasBundleUpsellProp(item)) return true;
      const bundleId = String(product?.widgetId || "").trim();
      const lineWidget = getCartUpsellLineProp(item, "_widget_id");
      const oldWidget = getCartUpsellLineProp(item, "_old_widget_id");
      // Saved single-widget id means this line was promoted into the bundle.
      if (oldWidget) return true;
      return Boolean(bundleId && lineWidget && lineWidget === bundleId);
    }

    function cartHasLuxurySeatCover() {
      const items = Array.isArray(state.cart?.items) ? state.cart.items : [];
      return items.some((item) => {
        if (hasSeatCover(item)) return true;
        const props = item?.properties && typeof item.properties === "object"
          ? item.properties
          : {};
        return Boolean(
          props._seat ||
            props["Your Vehicle"] ||
            props._your_vehicle,
        );
      });
    }

    function getPremiumUpsellBundleState() {
      const cfg = getCartDrawerNewConfig();
      if (!isPremiumCartUpsellActive() || !cfg?.products?.length || !state.cart?.items?.length) {
        return { active: false, items: [] };
      }

      if (!cartHasLuxurySeatCover()) {
        return { active: false, items: [] };
      }

      const items = [];
      for (const product of cfg.products) {
        const matches = state.cart.items.filter(
          (item) =>
            isPremiumCartUpsellLine(item) &&
            String(item.variant_id ?? item.id ?? "") === String(product.variantId),
        );
        // Prefer an explicit bundle line, then widget-based bundle, then any upsell line.
        const match =
          matches.find((item) => hasBundleUpsellProp(item)) ||
          matches.find((item) => isPremiumBundleLine(item, product)) ||
          matches.find((item) => hasPremiumWidgetId(item)) ||
          matches[0] ||
          null;
        if (!match) return { active: false, items: [] };
        items.push(match);
      }

      // Bundle UI unlocks once every configured upsell product is in the cart.
      return { active: items.length === cfg.products.length, items, config: cfg };
    }

    function getPremiumBundleSavingCents(cfg, items) {
      const products = Array.isArray(cfg?.products) ? cfg.products : [];
      const totalOriginal = products.reduce(
        (sum, p) => sum + (Number(p.msrpCents) || 0),
        0,
      );
      const liveItems = Array.isArray(items) ? items : [];
      const liveTotal = liveItems.reduce((sum, item) => sum + getLineSaleCents(item), 0);
      return Math.max(0, totalOriginal - liveTotal);
    }

    function partitionRegularLineItems(regular) {
      const bundleState = getPremiumUpsellBundleState();
      const upsellBundle = [];
      const upsellIndividual = [];
      const seatCovers = [];
      const others = [];

      const bundleKeys = new Set(
        (bundleState.items || []).map((item) => item.key || item.id),
      );

      regular.forEach((item) => {
        if (bundleState.active && bundleKeys.has(item.key || item.id)) {
          upsellBundle.push(item);
          return;
        }
        if (isPremiumCartUpsellLine(item)) {
          upsellIndividual.push(item);
          return;
        }
        if (hasSeatCover(item)) {
          seatCovers.push(item);
          return;
        }
        others.push(item);
      });

      if (bundleState.active && upsellBundle.length) {
        const order = bundleState.config.products.map((p) =>
          String(p.variantId),
        );
        upsellBundle.sort(
          (a, b) =>
            order.indexOf(String(a.variant_id)) -
            order.indexOf(String(b.variant_id)),
        );
      }

      return { bundleState, upsellBundle, upsellIndividual, seatCovers, others };
    }

    function renderPremiumUpsellBundleGroup(bundleState) {
      if (!bundleState?.active || !bundleState.items?.length) return "";

      const cfg = bundleState.config;
      const count = cfg.products.length;
      const bundleCents = (bundleState.items || []).reduce(
        (sum, item) => sum + getLineSaleCents(item),
        0,
      );
      const saveCents = getPremiumBundleSavingCents(cfg, bundleState.items);
      const tabLabel = `Unlocked — All ${count} For ${toBadgeMoney(bundleCents)} (Save ${toBadgeMoney(saveCents)})`;
      const lines = bundleState.items
        .map((item) => renderLineItem(item, { bundleMode: true }))
        .join("");

      return `
        <section class="SCS_CART_02__premium-bundle" aria-label="Premium add-on bundle">
          <span class="SCS_CART_02__premium-bundle-tab">${htmlEscape(tabLabel)}</span>
          <div class="SCS_CART_02__premium-bundle-items">${lines}</div>
        </section>
      `;
    }

    function getLineItemUnitCompareCents(item, saleCents, options = {}) {
      const resolvedSale =
        saleCents != null ? saleCents : getLineItemUnitSaleCents(item, options);
      const upsell = getPremiumCartUpsellDisplayPricing(item, options);
      if (upsell?.compareCents) return upsell.compareCents;

      const candidates = [];

      const pushIfHigher = (value) => {
        const cents = Number(value) || 0;
        if (cents > resolvedSale) candidates.push(cents);
      };

      pushIfHigher(item.compare_at_price);
      pushIfHigher(item.variant_compare_at_price);

      const cached = variantCompareCache.get(Number(item.variant_id));
      if (cached?.compare_at_price) pushIfHigher(cached.compare_at_price);

      pushIfHigher(getDealVariantCompareFromState(item.variant_id));
      pushIfHigher(item.original_price);

      return candidates.length ? Math.max(...candidates) : 0;
    }

    async function enrichLineItemComparePrices(cart = state.cart) {
      if (!cart?.items?.length) { console.log("[SCS_CART_02] enrich: no items"); return; }

      const generation = ++lineItemCompareEnrichGen;
      const variantIds = new Set();

      cart.items.forEach((item) => {
        const variantId = Number(item.variant_id);
        if (!variantId || variantCompareCache.has(variantId)) return;
        const sale = getLineItemUnitSaleCents(item);
        const hasRealCompare =
          Number(item.compare_at_price) > sale ||
          Number(item.variant_compare_at_price) > sale ||
          getDealVariantCompareFromState(item.variant_id) > sale;
        console.log("[SCS_CART_02] enrich item", variantId, "sale:", sale, "hasRealCompare:", hasRealCompare);
        if (hasRealCompare) return;
        variantIds.add(variantId);
      });

      if (!variantIds.size) { console.log("[SCS_CART_02] enrich: no variants to fetch (all cached or already have compare)"); return; }
  
      await Promise.all(
        [...variantIds].map(async (variantId) => {
          try {
            const variant = await apiFetch(`/variants/${variantId}.js`, { cache: "no-store" });
            if (generation !== lineItemCompareEnrichGen) return;
            console.log("[SCS_CART_02] variant compare", variantId, variant.compare_at_price, variant.price);
            variantCompareCache.set(variantId, {
              compare_at_price: Number(variant.compare_at_price) || 0,
              price: Number(variant.price) || 0,
            });
          } catch {
            variantCompareCache.set(variantId, null);
          }
        })
      );
  
      if (generation === lineItemCompareEnrichGen) {
        render(true);
      }
    }
  
    function scheduleLineItemCompareEnrichment(cart = state.cart) {
      void enrichLineItemComparePrices(cart);
    }
  
    function htmlEscape(value) {
      return String(value || "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;");
    }
  
    function hasSeatCover(item) {
      const text = `${item?.product_title || ""} ${item?.handle || ""}`.toLowerCase();
      const keywords = ["seat cover", "seat-cover", "luxury seat"];
      return keywords.some((k) => text.includes(k));
    }
  
    function hasPurchasedItemDiscount(item) {
      if ((item?.discounts || []).length) return true;
      if ((item?.line_level_discount_allocations || []).length) return true;
      const original = Number(item?.original_price ?? item?.price ?? 0);
      const sale = getLineItemUnitSaleCents(item);
      return original > sale;
    }

    function isFreeItemDiscount(item) {
      return getLineItemDiscountTitles(item).some((title) => title.toLowerCase().includes("free item"));
    }

    function isPurchasedWithDiscountCode(item) {
      if (Number(item?.final_price) !== 0) return false;
      if (isFreeItemDiscount(item)) return false;
      return hasPurchasedItemDiscount(item);
    }

    function isGiftItem(item) {
      const title = (item?.product_title || "").toLowerCase();
      const hasGiftProp = Object.keys(item?.properties || {}).some((k) => k.toLowerCase().includes("gift"));
      const keywords = ["free gift", "warranty", "microfiber", "gift"];
      if (hasGiftProp || keywords.some((k) => title.includes(k))) return true;
      if (item.final_price === 0 && isPurchasedWithDiscountCode(item)) return false;
      return item.final_price === 0;
    }

    function getLineItemDiscountTitles(item) {
      const titles = new Set();
      (item?.discounts || []).forEach((discount) => {
        const title = String(discount?.title || "").trim();
        if (title) titles.add(title);
      });
      (item?.line_level_discount_allocations || []).forEach((allocation) => {
        const title = String(allocation?.discount_application?.title || "").trim();
        if (title) titles.add(title);
      });
      return [...titles];
    }

    const CART_SUMMARY_COUPON_CODES = ["FORDTX20"];

    function normalizeCouponCode(value) {
      return String(value || "").replace(/\s+/g, "").toUpperCase();
    }

    function isCartSummaryCoupon(value) {
      const code = normalizeCouponCode(value);
      return CART_SUMMARY_COUPON_CODES.some((target) => code.includes(target));
    }

    function parseDiscountAmountCents(value) {
      if (value == null || value === "") return 0;
      if (typeof value === "number") {
        if (!Number.isFinite(value) || value <= 0) return 0;
        return value >= 100 || Number.isInteger(value) ? Math.round(value) : Math.round(value * 100);
      }
      const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
      if (!Number.isFinite(parsed) || parsed <= 0) return 0;
      return String(value).includes(".") ? Math.round(parsed * 100) : Math.round(parsed);
    }

    function addSummaryCouponAmount(map, rawCode, amount) {
      const code = normalizeCouponCode(rawCode);
      if (!isCartSummaryCoupon(code)) return;
      const cents = parseDiscountAmountCents(amount);
      if (cents <= 0) return;
      const key = CART_SUMMARY_COUPON_CODES.find((target) => code.includes(target)) || code;
      map.set(key, (map.get(key) || 0) + cents);
    }

    function getCartSummaryCoupons(cart = state.cart) {
      const totals = new Map();
      if (!cart) return [];

      (cart.cart_level_discount_applications || []).forEach((app) => {
        addSummaryCouponAmount(totals, app.code || app.title, app.total_allocated_amount);
      });

      if (!totals.size) {
        (cart.items || []).forEach((item) => {
          const seen = new Set();
          (item.line_level_discount_allocations || []).forEach((allocation) => {
            const title = allocation?.discount_application?.title || allocation?.discount_application?.code;
            const key = `${item.key}:${normalizeCouponCode(title)}`;
            if (seen.has(key)) return;
            seen.add(key);
            addSummaryCouponAmount(totals, title, allocation.amount);
          });
          (item.discounts || []).forEach((discount) => {
            const title = discount?.title;
            const key = `${item.key}:${normalizeCouponCode(title)}`;
            if (seen.has(key)) return;
            seen.add(key);
            addSummaryCouponAmount(totals, title, discount.amount);
          });
        });
      }

      if (!totals.size) {
        (cart.discount_codes || []).forEach((entry) => {
          if (entry?.applicable === false) return;
          addSummaryCouponAmount(totals, entry.code, entry.amount);
        });
      }

      return [...totals.entries()].map(([code, amountCents]) => ({ code, amountCents }));
    }
  
    function getDealHandle() {
      return cfg.dealHandle || "petsuite-hard-bottom-dog-seat-protector-no-fur";
    }
  
    function getRebuyProductTitle(p) {
      return p?.title || p?.product_title || p?.name || "";
    }
  
    function getRebuyProductHandle(p) {
      return String(p?.handle || p?.product_handle || "").toLowerCase();
    }
  
    function isBlockedCartProduct(item) {
      if (!item) return false;
      if (BLOCKED_CART_PRODUCT_IDS.includes(Number(item.product_id))) return true;
      const title = String(item.product_title || getRebuyProductTitle(item) || "").toLowerCase();
      return title.includes("free returns") && title.includes("package protection");
    }
  
    function isDealCatalogProduct(product) {
      if (!product) return false;
      const dealHandle = getDealHandle().toLowerCase();
      const handle = String(product.handle || "").toLowerCase();
      if (handle && handle === dealHandle) return true;
      const title = String(product.title || "").toLowerCase();
      return title.includes("petsuite") && title.includes("seat protector");
    }
  
    function isDealCatalogRebuyProduct(p) {
      return isDealCatalogProduct({
        handle: getRebuyProductHandle(p),
        title: getRebuyProductTitle(p),
      });
    }
  
    function pickDealProductFromRebuyProducts(products) {
      if (!Array.isArray(products)) return null;
      const match = products.find(isDealCatalogRebuyProduct);
      return match ? normalizeRebuyDealProduct(match) : null;
    }
  
    function getExcludedUpsellVariantIds() {
      return new Set(
        (state.cart?.items || [])
          .map((item) => Number(item.variant_id))
          .filter(Boolean)
      );
    }
  
    function isUpsellExcludedRebuyProduct(p) {
      if (!p) return true;
      return isBlockedCartProduct({ product_id: p.id || p.product_id, product_title: getRebuyProductTitle(p) });
    }
  
    function scheduleBlockedProductRemoval() {
      clearTimeout(blockedRemovalTimer);
      blockedRemovalTimer = setTimeout(() => {
        void removeBlockedCartItems();
      }, 120);
    }
  
    async function removeBlockedCartItems() {
      if (blockedRemovalInProgress || !state.cart?.items?.length) return;
      const lines = state.cart.items
        .map((item, index) => ({ item, line: index + 1 }))
        .filter(({ item }) => isBlockedCartProduct(item));
      if (!lines.length) return;
  
      blockedRemovalInProgress = true;
      try {
        for (const { line } of [...lines].reverse()) {
          await apiFetch("/cart/change.js", {
            method: "POST",
            body: JSON.stringify({ line, quantity: 0 }),
          });
        }
        await pullCartFromServer(true);
      } catch (err) {
        console.warn("[SCS_CART_02] blocked product removal failed:", err);
      } finally {
        blockedRemovalInProgress = false;
      }
    }
  
    function getDealTitle() {
      const handle = getDealHandle();
      return (
        cfg.dealProducts?.[handle]?.title ||
        cfg.dealTitle ||
        state.deal.product?.title ||
        "PetSuite Back Seat Protector"
      );
    }
  
    function getDealImage() {
      const handle = getDealHandle();
      return (
        cfg.dealImageUrl ||
        cfg.dealProducts?.[handle]?.imageUrl ||
        state.deal.product?.featured_image ||
        ""
      );
    }
  
    function getDealVariantText(variant) {
      return [variant?.title, variant?.option1, variant?.option2, variant?.option3, variant?.public_title]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
    }
  
    function matchDealFitVariant(variants, fit) {
      if (!variants?.length) return null;
      const cfgLabels = cfg.dealFitLabels?.[fit];
      const truckLabels = cfg.dealFitLabels?.truck || ["truck"];
      const carLabels = cfg.dealFitLabels?.car || ["car", "suv"];
  
      const matchesLabels = (variant, labels) => {
        const text = getDealVariantText(variant);
        return labels.some((label) => text.includes(String(label).toLowerCase()));
      };
  
      if (Array.isArray(cfgLabels) && cfgLabels.length) {
        const match = variants.find((variant) => matchesLabels(variant, cfgLabels));
        if (match) return match;
      }
  
      if (fit === "truck") {
        const truckMatch = variants.find((variant) => matchesLabels(variant, truckLabels));
        if (truckMatch) return truckMatch;
      } else {
        const carMatch = variants.find((variant) => {
          const text = getDealVariantText(variant);
          const isTruck = truckLabels.some((label) => text.includes(String(label).toLowerCase()));
          return !isTruck && matchesLabels(variant, carLabels);
        });
        if (carMatch) return carMatch;
      }
  
      if (variants.length === 2) {
        return fit === "truck" ? variants[1] : variants[0];
      }
      if (variants.length === 1) return variants[0];
      return null;
    }
  
    function getDealDiscountCents() {
      const value = Number(cfg.dealDiscountCents);
      return Number.isFinite(value) && value > 0 ? value : 7000;
    }
  
    function syncDealVariantPricing(variant, fit) {
      const listPrice = Number(variant?.price) || 0;
      const stickerCompare = Number(variant?.compare_at_price) || 0;
      const cfgCompare = Number(cfg.dealCompareAts?.[fit]) || 0;
      const cfgSale = Number(cfg.dealPrices?.[fit]) || 0;
      const dealDiscount = getDealDiscountCents();
      const fitDefaults = {
        car: { compareAt: 17900, sale: 10900 },
        truck: { compareAt: 18900, sale: 11900 },
      };
      const defaults = fitDefaults[fit] || fitDefaults.car;
  
      if (cfgSale > 0 && cfgCompare > cfgSale) {
        return { sale: cfgSale, compareAt: cfgCompare };
      }
  
      if (stickerCompare > listPrice && listPrice > 0) {
        return { sale: listPrice, compareAt: stickerCompare };
      }
  
      const compareAt = cfgCompare || listPrice || defaults.compareAt;
      const sale = cfgSale > 0 ? cfgSale : Math.max(0, compareAt - dealDiscount);
      return { sale, compareAt: compareAt > sale ? compareAt : defaults.compareAt };
    }
  
    function syncDealPricingFromCartItem(item) {
      if (!item) return;
      const variantId = Number(item.variant_id);
      const ids = getDealVariantIds();
      let fit = null;
      if (Number(ids.car) === variantId) fit = "car";
      else if (Number(ids.truck) === variantId) fit = "truck";
      if (!fit) return;
  
      const sale = getLineItemUnitSaleCents(item);
      const compare = getLineItemUnitCompareCents(item, sale);
      if (sale > 0) state.deal.prices[fit] = sale;
      if (compare > sale) {
        state.deal.compareAts[fit] = compare;
        return;
      }
      if (sale > 0) {
        state.deal.compareAts[fit] = sale + getDealDiscountCents();
      }
    }
  
    function syncDealFromProduct(product) {
      if (!product?.variants?.length) return;
      const cfgMap = cfg.dealVariantIds || {};
      const variantIds = {
        car: cfgMap.car || state.deal.variantIds?.car || null,
        truck: cfgMap.truck || state.deal.variantIds?.truck || null,
      };
  
      const carVariant = matchDealFitVariant(product.variants, "car");
      const truckVariant = matchDealFitVariant(product.variants, "truck");
      if (!variantIds.car && carVariant) variantIds.car = carVariant.id;
      if (!variantIds.truck && truckVariant) variantIds.truck = truckVariant.id;
  
      state.deal.variantIds = variantIds;
  
      ["car", "truck"].forEach((fit) => {
        const variantId = variantIds[fit];
        if (!variantId) return;
        const variant = product.variants.find((v) => Number(v.id) === Number(variantId));
        if (!variant) return;
        const pricing = syncDealVariantPricing(variant, fit);
        state.deal.prices[fit] = pricing.sale;
        state.deal.compareAts[fit] = pricing.compareAt;
      });
    }
  
    function getStoredDealSnapshot() {
      try {
        const raw = localStorage.getItem(DEAL_SNAPSHOT_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        return data?.product?.variants?.length ? data : null;
      } catch {
        return null;
      }
    }
  
    function saveDealSnapshot() {
      if (!state.deal.product?.variants?.length) return;
      try {
        localStorage.setItem(
          DEAL_SNAPSHOT_KEY,
          JSON.stringify({
            product: state.deal.product,
            variantIds: state.deal.variantIds,
            prices: state.deal.prices,
            compareAts: state.deal.compareAts,
            fit: state.deal.fit,
          })
        );
      } catch (err) {
        console.warn("[SCS_CART_02] Could not save deal snapshot:", err);
      }
    }
  
    function restoreDealSnapshot() {
      const data = getStoredDealSnapshot();
      if (!data) return false;
      if (!isDealCatalogProduct(data.product)) {
        clearDealSnapshot();
        return false;
      }
      state.deal.product = data.product;
      if (data.variantIds) state.deal.variantIds = { ...state.deal.variantIds, ...data.variantIds };
      if (data.prices) state.deal.prices = data.prices;
      if (data.compareAts) state.deal.compareAts = data.compareAts;
      if (data.fit) state.deal.fit = data.fit;
      syncDealFromProduct(state.deal.product);
      return true;
    }
  
    function clearDealSnapshot() {
      try {
        localStorage.removeItem(DEAL_SNAPSHOT_KEY);
      } catch (err) {
        console.warn("[SCS_CART_02] Could not clear deal snapshot:", err);
      }
    }
  
    function setDealProduct(product) {
      if (!product?.variants?.length || !isDealCatalogProduct(product)) return false;
      state.deal.product = product;
      syncDealFromProduct(product);
      saveDealSnapshot();
      return true;
    }
  
    function getKnownDealVariantIds(cart = state.cart) {
      const ids = new Set();
      Object.values(cfg.dealVariantIds || {}).forEach((id) => {
        if (id) ids.add(Number(id));
      });
      Object.values(state.deal.variantIds || {}).forEach((id) => {
        if (id) ids.add(Number(id));
      });
      (state.deal.product?.variants || []).forEach((variant) => {
        if (variant.id) ids.add(Number(variant.id));
      });
      const stored = getStoredDealSnapshot();
      if (stored) {
        Object.values(stored.variantIds || {}).forEach((id) => {
          if (id) ids.add(Number(id));
        });
        (stored.product?.variants || []).forEach((variant) => {
          if (variant.id) ids.add(Number(variant.id));
        });
      }
      return ids;
    }
  
    function findDealCartItem(cart = state.cart) {
      if (!cart?.items?.length) return null;
      const ids = getKnownDealVariantIds(cart);
      for (const item of cart.items) {
        if (ids.has(Number(item.variant_id))) return item;
      }
      const handle = getDealHandle();
      if (handle) {
        const match = cart.items.find((item) => item.handle === handle);
        if (match) return match;
      }
      const stored = getStoredDealSnapshot();
      const storedHandle = stored?.product?.handle;
      if (storedHandle) {
        const match = cart.items.find((item) => item.handle === storedHandle);
        if (match) return match;
      }
      return null;
    }
  
    function syncDealFitFromCartItem(item) {
      if (!item?.variant_id) return;
      const variantId = Number(item.variant_id);
      const ids = getDealVariantIds();
      if (Number(ids.truck) === variantId) state.deal.fit = "truck";
      else if (Number(ids.car) === variantId) state.deal.fit = "car";
    }

    function detectFitFromSeatItems() {
      const seatItems = getSeatItems();
      if (!seatItems.length) return;
      const truckLabels = cfg.dealFitLabels?.truck || ["truck"];
      const hasTruck = seatItems.some((item) => {
        const text = [
          item.variant_title,
          ...(item.options_with_values || []).map((o) => String(o.value || "")),
          ...Object.values(item.properties || {}),
        ].filter(Boolean).join(" ").toLowerCase();
        return truckLabels.some((label) => text.includes(String(label).toLowerCase()));
      });
      state.deal.fit = hasTruck ? "truck" : "car";
    }
  
    async function resolveDealProductFromCart(cart = state.cart) {
      const dealItem = findDealCartItem(cart);
      if (!dealItem) return false;
  
      if (state.deal.product?.variants?.length) {
        syncDealFitFromCartItem(dealItem);
        saveDealSnapshot();
        return true;
      }
  
      if (!dealItem.handle) return false;
      try {
        const product = await apiFetch(`/products/${dealItem.handle}.js`, { cache: "no-store" });
        setDealProduct(product);
        syncDealFitFromCartItem(dealItem);
        saveDealSnapshot();
        return true;
      } catch (err) {
        console.warn("[SCS_CART_02] resolveDealProductFromCart failed:", err);
        return false;
      }
    }
  
    async function fetchDealProduct() {
      const handle = getDealHandle();
      if (!handle) return null;
      try {
        const product = await apiFetch(`/products/${handle}.js`, { cache: "no-store" });
        setDealProduct(product);
        return product;
      } catch (err) {
        console.warn("[SCS_CART_02] Could not load deal product:", handle, err);
        return null;
      }
    }
  
    function getDealVariantIds() {
      const cfgMap = cfg.dealVariantIds || {};
      return {
        car: cfgMap.car || state.deal.variantIds?.car || null,
        truck: cfgMap.truck || state.deal.variantIds?.truck || null,
      };
    }
  
    function getDealVariantId() {
      const ids = getDealVariantIds();
      return state.deal.fit === "truck" ? ids.truck : ids.car;
    }
  
    async function ensureDealVariantId() {
      let variantId = Number(getDealVariantId());
      if (variantId) return variantId;
      await fetchDealProduct();
      variantId = Number(getDealVariantId());
      return variantId || null;
    }
  
    async function apiFetch(path, options = {}) {
      const res = await fetch(path, {
        headers: { "Content-Type": "application/json" },
        ...options,
      });
      if (!res.ok) throw new Error(`Request failed: ${res.status}`);
      return res.json();
    }
  
    async function loadDealFromRebuyWidget(options = {}) {
      if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) {
        syncDealFromProduct(state.deal.product);
        return true;
      }
  
      if (dealFetchPromise) {
        await dealFetchPromise;
        return Boolean(state.deal.product?.variants?.length);
      }
  
      dealFetchPromise = (async () => {
        try {
          if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) {
            syncDealFromProduct(state.deal.product);
            return true;
          }
  
          ensureRebuyWidgetHost(REBUY_UPSELL_WIDGET_ID);
          const widget = await waitForRebuyWidget(REBUY_UPSELL_WIDGET_ID, 8000);
          if (!widget) return false;
  
          applyCartContextToWidget(widget);
          if (syncDealFromRebuyWidget()) return true;
  
          let products = await fetchProductsFromWidget(widget);
          if (!products.length) products = await fetchProductsFromRebuyApi(widget);
          if (!products.length) return false;
  
          if (state.deal.product?.variants?.length) {
            syncDealFromProduct(state.deal.product);
            return true;
          }
  
          const product = pickDealProductFromRebuyProducts(products);
          if (!product?.variants?.length) return false;
  
          setDealProduct(product);
          return true;
        } catch (err) {
          console.warn("[SCS_CART_02] loadDealFromRebuyWidget failed:", err);
          return false;
        } finally {
          dealFetchPromise = null;
        }
      })();
  
      let loaded = await dealFetchPromise;
      if (!loaded && !state.deal.product) {
        await fetchDealProduct();
        loaded = Boolean(state.deal.product?.variants?.length);
      }
  
      if (loaded && options.render !== false && getSeatItems().length) {
        render(true);
      }
      return loaded;
    }
  
    function scheduleDealLoad() {
      if (!state.cart || getSeatItems().length === 0) return;
      if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) return;
      void loadDealProductData(state.cart).then((product) => {
        if (product && getSeatItems().length) render(true);
      });
    }
  
    async function loadDealProductData(cart = state.cart) {
      if (state.deal.product?.variants?.length && isDealCatalogProduct(state.deal.product)) {
        syncDealFromProduct(state.deal.product);
        return state.deal.product;
      }
      if (restoreDealSnapshot()) {
        if (cart) {
          const dealItem = findDealCartItem(cart);
          if (dealItem) syncDealFitFromCartItem(dealItem);
        }
        return state.deal.product;
      }
      if (cart && (await resolveDealProductFromCart(cart)) && isDealCatalogProduct(state.deal.product)) {
        return state.deal.product;
      }
      const fetched = await fetchDealProduct();
      if (fetched) return fetched;
      const loaded = await loadDealFromRebuyWidget({ render: false });
      return loaded && isDealCatalogProduct(state.deal.product) ? state.deal.product : null;
    }
  
    function isUpsellSyncing() {
      return Boolean(window.SCS_EMPTY_CART_01?.isCartUpsellSyncing?.());
    }

    function isUpsellQuiet() {
      return Boolean(window.SCS_EMPTY_CART_01?.isCartUpsellQuiet?.());
    }

    function shouldSuppressExternalCartRefresh() {
      return Boolean(
        state.refreshing ||
          state.silentRefreshing ||
          isUpsellSyncing() ||
          isUpsellQuiet() ||
          window.SCS_EMPTY_CART_01?.shouldSkipUpsellSync?.(),
      );
    }

    async function refreshCartData() {
      const cart = await apiFetch("/cart.js", { cache: "no-store" });
      if (!state.deal.product?.variants?.length) {
        await loadDealProductData(cart);
      }
      applyCartFromServer(cart);
      return cart;
    }
  
    async function pullCartFromServer(forceRender = true) {
      const cart = await apiFetch("/cart.js", { cache: "no-store" });
      applyCartFromServer(cart);
      if (forceRender) render(true);
      return cart;
    }
  
    function scheduleCartRefreshFromRebuy() {
      if (shouldSuppressExternalCartRefresh()) return;
      clearTimeout(rebuyCartRefreshTimer);
      rebuyCartRefreshTimer = setTimeout(() => {
        if (shouldSuppressExternalCartRefresh()) return;
        void pullCartFromServer(true).catch((err) => {
          console.warn("[SCS_CART_02] rebuy cart sync failed:", err);
        });
      }, 150);
    }
  
    function holdRefresh(on) {
      if (on) refreshHold += 1;
      else refreshHold = Math.max(0, refreshHold - 1);
      state.refreshing = refreshHold > 0;
      setRefreshUi();
    }

    function setRefreshUi() {
      if (!root) return;
      const isInitialLoad = shouldShowCartSkeleton();
      const isRefreshing = state.refreshing || refreshHold > 0;
      root.classList.toggle("is-refreshing", isRefreshing);
      root.classList.toggle("is-loading", isInitialLoad);
      const drawer = root.querySelector(".SCS_CART_02__drawer");
      const overlay = root.querySelector(".SCS_CART_02__refresh-overlay");
      drawer?.setAttribute("aria-busy", isInitialLoad || isRefreshing ? "true" : "false");
      overlay?.setAttribute("aria-hidden", isRefreshing ? "false" : "true");
    }
  
    async function fetchCart(options = {}) {
      if (activeCartFetch) {
        await activeCartFetch;
        return state.cart;
      }
  
      const hasCart = cartHasVisibleItems();
      const silent = options.silent !== undefined ? options.silent : hasCart;
  
      if (!silent) {
        state.loading = true;
        render(true);
      } else {
        state.refreshing = true;
        setRefreshUi();
      }
  
      activeCartFetch = (async () => {
        try {
          await refreshCartData();
        } catch (err) {
          if (!silent) showToast("Could not load cart. Retrying...");
          console.error(err);
        } finally {
          state.loading = false;
          if (refreshHold === 0) state.refreshing = false;
          setRefreshUi();
          render(true);
        }
      })();
  
      try {
        await activeCartFetch;
      } finally {
        activeCartFetch = null;
      }
      return state.cart;
    }
  
    function getLineNumber(item) {
      if (!state.cart?.items?.length || !item?.key) return 0;
      const idx = state.cart.items.findIndex((x) => x.key === item.key);
      return idx >= 0 ? idx + 1 : 0;
    }
  
    function setStepperLoading(btn, loading) {
      if (!btn) return;
      if (loading) {
        if (!btn.dataset.scsQtyContent) btn.dataset.scsQtyContent = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add("is-loading");
        btn.innerHTML = '<span class="SCS_CART_02__qty-spinner" aria-hidden="true"></span>';
        return;
      }
      btn.disabled = false;
      btn.classList.remove("is-loading");
      if (btn.dataset.scsQtyContent) {
        btn.innerHTML = btn.dataset.scsQtyContent;
        delete btn.dataset.scsQtyContent;
      }
    }
  
    function setCheckoutLoading(btn, loading) {
      if (!btn) return;
      if (loading) {
        btn.disabled = true;
        btn.classList.add("is-loading");
        btn.innerHTML = '<span class="SCS_CART_02__checkout-spinner" aria-hidden="true"></span><span>Processing...</span>';
        btn.setAttribute("aria-busy", "true");
        return;
      }
      btn.disabled = false;
      btn.classList.remove("is-loading");
      btn.removeAttribute("aria-busy");
      btn.innerHTML = "\ud83d\udd12 Secure Checkout";
    }
  
    function getCartSubtotalCents(cart = state.cart) {
      if (!cart) return 0;
      return cart.items_subtotal_price ?? cart.total_price ?? 0;
    }
  
    function cartHasVisibleItems(cart = state.cart) {
      return Boolean(cart?.items?.length || cart?.item_count);
    }
  
    function shouldShowCartSkeleton() {
      return state.loading && !cartHasVisibleItems();
    }
  
    function applyCartFromServer(cart, options = {}) {
      state.cart = cart;
      scheduleBlockedProductRemoval();
      if (getSeatItems().length === 0) {
        state.deal.product = null;
        clearDealSnapshot();
      } else if (state.deal.product) {
        syncDealFromProduct(state.deal.product);
        const dealItem = findDealCartItem(cart);
        if (dealItem) {
          syncDealFitFromCartItem(dealItem);
          syncDealPricingFromCartItem(dealItem);
        } else {
          detectFitFromSeatItems();
        }
      } else {
        const dealItem = findDealCartItem(cart);
        if (dealItem) syncDealPricingFromCartItem(dealItem);
        else detectFitFromSeatItems();
      }
      const sig = getRebuyCartSignature();
      if (sig !== rebuyCartSignature) {
        rebuyCartSignature = sig;
        if (!options.quiet) {
          rebuyLoadGeneration += 1;
          rebuyFetchPromise = null;
        }
      }
      if (options.quiet) return;
      scheduleRebuyLoad({ force: true, showSkeleton: !state.recommendations.length });
      scheduleDealLoad();
      scheduleLineItemCompareEnrichment(cart);
    }

    function applyCartSilent(cart) {
      if (!cart) return;
      applyCartFromServer(cart, { quiet: true });
      render(true);
      window.SCS_EMPTY_CART_01?.restoreCartUpsellHost?.();
    }
  
    async function refreshCartSilent() {
      if (state.silentRefreshing || state.refreshing) return;
      state.silentRefreshing = true;
      try {
        const cart = await apiFetch("/cart.js", { cache: "no-store" });
        applyCartFromServer(cart);
        const skipSync = Boolean(window.SCS_EMPTY_CART_01?.shouldSkipUpsellSync?.());
        if (!skipSync) {
          const synced = await window.SCS_EMPTY_CART_01?.awaitCartUpsellSync?.(cart);
          if (synced?.cart) applyCartFromServer(synced.cart);
        }
        render(true);
        window.SCS_EMPTY_CART_01?.restoreCartUpsellHost?.();
      } catch (err) {
        console.warn("[SCS_CART_02] silent refresh failed:", err);
      } finally {
        state.silentRefreshing = false;
      }
    }

    function isCartBusy() {
      return Boolean(state.refreshing || refreshHold > 0 || state.loading || state.silentRefreshing);
    }

    async function changePremiumUpsellLine(item, quantity, triggerBtn) {
      const api = window.SCS_EMPTY_CART_01;
      if (!api?.changePremiumUpsellQuantity) {
        return changeLine(getLineNumber(item), quantity, triggerBtn);
      }
      holdRefresh(true);
      try {
        const result = await api.changePremiumUpsellQuantity(item, quantity);
        applyCartSilent(result?.cart);
      } catch (err) {
        showToast(quantity <= 0 ? "Unable to remove item." : "Unable to update quantity.");
        console.error(err);
      } finally {
        holdRefresh(false);
      }
    }

    async function addExtraPremiumUpsell(item, triggerBtn) {
      const api = window.SCS_EMPTY_CART_01;
      if (!api?.addExtraUpsellQuantity) {
        return changeLine(getLineNumber(item), (item.quantity || 1) + 1, triggerBtn);
      }
      if (triggerBtn) setStepperLoading(triggerBtn, true);
      state.refreshing = true;
      setRefreshUi();
      try {
        const result = await api.addExtraUpsellQuantity(item);
        applyCartSilent(result?.cart);
      } catch (err) {
        showToast("Unable to update quantity.");
        console.error(err);
      } finally {
        state.refreshing = false;
        setRefreshUi();
        if (triggerBtn) setStepperLoading(triggerBtn, false);
      }
    }

    async function changeLine(line, quantity, triggerBtn) {
      const isRemove = quantity <= 0;
      if (triggerBtn) setStepperLoading(triggerBtn, true);
  
      const snapshot = state.cart ? JSON.parse(JSON.stringify(state.cart)) : null;
      state.refreshing = true;
      setRefreshUi();
  
      try {
        await apiFetch("/cart/change.js", {
          method: "POST",
          body: JSON.stringify({ line, quantity }),
        });
        const cart = await apiFetch("/cart.js", { cache: "no-store" });
        applyCartFromServer(cart, { quiet: true });
        render(true);
        window.SCS_EMPTY_CART_01?.restoreCartUpsellHost?.();
      } catch (err) {
        if (snapshot) {
          state.cart = snapshot;
          render(true);
        }
        showToast(isRemove ? "Unable to remove item." : "Unable to update quantity.");
        console.error(err);
      } finally {
        state.refreshing = false;
        setRefreshUi();
        if (triggerBtn) setStepperLoading(triggerBtn, false);
      }
    }
  
    async function postCartAdd(variantId, quantity, rebuyWidgetId) {
      const id = Number(variantId);
      const item = { id, quantity };
      if (rebuyWidgetId) {
        item.properties = { _widget_id: String(rebuyWidgetId) };
      }
      return apiFetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({ items: [item] }),
      });
    }
  
    async function addVariant(variantId, quantity = 1, rebuyWidgetId) {
      const id = Number(variantId);
      if (!id) {
        showToast("Offer is not configured yet.");
        return;
      }
      
      const api = window.SCS_EMPTY_CART_01;
      if (api?.addPremiumUpsellVariant) {
        const cfg = getCartDrawerNewConfig();
        const isPremiumUpsell = (cfg?.products || []).some(p => String(p.variantId) === String(id));
        if (isPremiumUpsell) {
          holdRefresh(true);
          try {
            const result = await api.addPremiumUpsellVariant(id);
            applyCartSilent(result?.cart);
          } catch (err) {
            showToast("Unable to add this item right now.");
            console.error(err);
          } finally {
            holdRefresh(false);
          }
          return;
        }
      }

      try {
        await postCartAdd(id, quantity, rebuyWidgetId);
        await pullCartFromServer(true);
      } catch (err) {
        showToast("Unable to add this item right now.");
        console.error(err);
      }
    }
  
    function getVisibleItems() {
      if (!state.cart?.items?.length) return [];
      return state.cart.items.filter((item) => {
        const title = (item?.product_title || "").toLowerCase();
        if (title.includes("rebuy")) return false;
        if (isBlockedCartProduct(item)) return false;
        return true;
      });
    }
  
    function getSeatItems() {
      return getVisibleItems().filter(hasSeatCover);
    }
  
    function getGiftItemKey(item) {
      const title = String(item?.product_title || "").toLowerCase().trim();
      if (title) return `title:${title}`;
      if (item?.product_id) return `product:${item.product_id}`;
      if (item?.variant_id) return `variant:${item.variant_id}`;
      const variant = String(item?.variant_title || "").toLowerCase().trim();
      return `title:${title}|${variant}`;
    }

    function getLineIdentity(item) {
      return String(item?.key || item?.id || `${item?.variant_id}:${item?.product_id}:${item?.product_title}`);
    }

    function getVehicleSignature(item) {
      const props = item?.properties && typeof item.properties === "object" ? item.properties : {};
      const parts = [];
      Object.entries(props).forEach(([k, v]) => {
        if (String(k).startsWith("_")) return;
        const key = String(k).toLowerCase();
        const val = String(v || "").trim().toLowerCase();
        if (!val) return;
        if (key.includes("vehicle") || key.includes("part") || key === "year" || key === "make" || key === "model") {
          parts.push(`${key}:${val}`);
        }
      });
      return parts.sort().join("|");
    }

    function getGiftBundleRules() {
      const rules = Array.isArray(cfg.giftBundles) ? cfg.giftBundles : [];
      return rules
        .map((rule) => ({
          variantIds: [...new Set((rule.variantIds || []).map(Number).filter(Boolean))],
          title: String(rule.title || "").trim(),
          image: String(rule.image || "").trim(),
          compareCents: Math.round(Number(rule.price || 0) * 100),
        }))
        .filter((rule) => rule.variantIds.length >= 2 && rule.title);
    }

    function collapseGiftItems(rawGifts) {
      const gifts = Array.isArray(rawGifts) ? rawGifts : [];
      const bundleForVariant = new Map();

      getGiftBundleRules().forEach((rule) => {
        const qtyByVariant = rule.variantIds.map((id) =>
          gifts
            .filter((item) => Number(item.variant_id) === id)
            .reduce((sum, item) => sum + (item.quantity || 1), 0)
        );
        const bundleQty = Math.min(...qtyByVariant);
        if (!bundleQty) return;

        const bundleEntry = {
          isBundle: true,
          product_title: rule.title,
          image: rule.image,
          compareCents: rule.compareCents,
          quantity: bundleQty,
        };
        rule.variantIds.forEach((id) => bundleForVariant.set(id, bundleEntry));
      });

      const result = [];
      const insertedBundles = new Set();
      const map = new Map();

      gifts.forEach((item) => {
        const bundleEntry = bundleForVariant.get(Number(item.variant_id));
        if (bundleEntry) {
          if (!insertedBundles.has(bundleEntry)) {
            insertedBundles.add(bundleEntry);
            result.push(bundleEntry);
          }
          return;
        }

        const key = getGiftItemKey(item);
        const compare = item.compareCents || getGiftCompareCents(item);
        const existing = map.get(key);
        if (existing) {
          existing.quantity = (existing.quantity || 0) + (item.quantity || 1);
          if (compare > (existing.compareCents || 0)) {
            existing.compareCents = compare;
          }
          if (!existing.image && (item.image || item.featured_image?.url)) {
            existing.image = item.image || item.featured_image?.url;
          }
        } else {
          const entry = { ...item, quantity: item.quantity || 1, compareCents: compare };
          map.set(key, entry);
          result.push(entry);
        }
      });

      return result;
    }

    function getGiftItems() {
      return collapseGiftItems(getVisibleItems().filter(isGiftItem));
    }

    function matchParentsForGift(gift, parents) {
      const props = gift?.properties && typeof gift.properties === "object" ? gift.properties : {};
      const hints = [];
      Object.entries(props).forEach(([k, v]) => {
        const key = String(k).toLowerCase();
        const val = String(v || "").trim();
        if (!val) return;
        if (key.includes("parent") || key === "_parent_key" || key === "_parent_id") hints.push(val);
      });
      if (hints.length) {
        const hit = parents.filter((parent) => {
          const id = getLineIdentity(parent);
          return hints.includes(id) || hints.includes(String(parent.key || "")) || hints.includes(String(parent.variant_id || ""));
        });
        if (hit.length) return hit;
      }
      const sig = getVehicleSignature(gift);
      if (sig) {
        const byVehicle = parents.filter((parent) => getVehicleSignature(parent) === sig);
        if (byVehicle.length) return byVehicle;
      }
      return matchParentsByColor(gift, parents);
    }

    function normalizeColorToken(value) {
      return String(value || "")
        .toLowerCase()
        .replace(/bundle\s*\/\s*/g, "")
        .replace(/&/g, " ")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
    }

    function colorsOverlap(a, b) {
      const left = normalizeColorToken(a);
      const right = normalizeColorToken(b);
      if (!left || !right) return false;
      if (left === right) return true;
      if (left.includes(right) || right.includes(left)) return true;
      const leftParts = left.split(" ").filter((part) => part.length > 2);
      const rightParts = right.split(" ").filter((part) => part.length > 2);
      if (!leftParts.length || !rightParts.length) return false;
      return rightParts.every((part) => leftParts.includes(part)) || leftParts.every((part) => rightParts.includes(part));
    }

    function matchParentsByColor(gift, parents) {
      const giftColor = getLineItemColor(gift) || getLineItemVariantText(gift);
      if (!giftColor) return [];
      return parents.filter((parent) => {
        const parentColor = getLineItemColor(parent) || getLineItemVariantText(parent);
        return colorsOverlap(giftColor, parentColor);
      });
    }

    function getParentSlots(parents) {
      const slots = [];
      (parents || []).forEach((parent) => {
        const qty = Math.max(1, Number(parent.quantity) || 1);
        for (let i = 0; i < qty; i++) slots.push(parent);
      });
      return slots;
    }

    function expandGiftUnits(gifts) {
      const units = [];
      (gifts || []).forEach((gift) => {
        const qty = Math.max(1, Number(gift.quantity) || 1);
        const compareCents = gift.compareCents || getGiftCompareCents(gift);
        for (let i = 0; i < qty; i++) {
          units.push({ ...gift, quantity: 1, compareCents });
        }
      });
      return units;
    }

    function assignUnitsRoundRobin(units, parents, byParent) {
      if (!units.length || !parents.length) return;
      const groups = new Map();
      units.forEach((unit) => {
        const key = getGiftItemKey(unit);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(unit);
      });
      const slots = getParentSlots(parents);
      if (!slots.length) return;
      groups.forEach((groupUnits) => {
        groupUnits.forEach((unit, index) => {
          const parent = slots[index % slots.length];
          byParent.get(getLineIdentity(parent)).push(unit);
        });
      });
    }

    function takeCartOrderGiftBlocks(parents) {
      const parentIds = new Set(parents.map(getLineIdentity));
      let currentParentId = null;
      let currentGifts = [];
      const blocks = [];

      const flush = () => {
        if (currentParentId && currentGifts.length) {
          blocks.push({ parentId: currentParentId, gifts: currentGifts });
        }
        currentGifts = [];
      };

      getVisibleItems().forEach((item) => {
        const id = getLineIdentity(item);
        if (parentIds.has(id)) {
          flush();
          currentParentId = id;
          return;
        }
        if (isGiftItem(item) && currentParentId) {
          currentGifts.push(item);
          return;
        }
        if (!isGiftItem(item)) {
          flush();
          currentParentId = null;
        }
      });
      flush();

      const parentsWithGifts = blocks.filter((block) => block.gifts.length);
      if (parents.length > 1 && parentsWithGifts.length <= 1) return null;
      return blocks;
    }

    function getGiftsByParent(parents) {
      const rawGifts = getVisibleItems().filter(isGiftItem);
      const byParent = new Map((parents || []).map((parent) => [getLineIdentity(parent), []]));
      if (!parents?.length) {
        return { byParent, leftovers: collapseGiftItems(rawGifts) };
      }

      const assignedKeys = new Set();
      const markAssigned = (gift) => {
        const token = `${gift.key || gift.id || ""}:${gift.variant_id || ""}`;
        assignedKeys.add(token);
      };
      const isAssigned = (gift) => assignedKeys.has(`${gift.key || gift.id || ""}:${gift.variant_id || ""}`);

      const cartBlocks = takeCartOrderGiftBlocks(parents);
      if (cartBlocks) {
        cartBlocks.forEach((block) => {
          expandGiftUnits(block.gifts).forEach((unit) => {
            byParent.get(block.parentId).push(unit);
            markAssigned(unit);
          });
        });
      }

      const remaining = [];
      rawGifts.forEach((gift) => {
        if (isAssigned(gift)) return;
        const matched = matchParentsForGift(gift, parents);
        if (matched.length === 1) {
          expandGiftUnits([gift]).forEach((unit) => {
            byParent.get(getLineIdentity(matched[0])).push(unit);
          });
          markAssigned(gift);
          return;
        }
        remaining.push(gift);
      });

      assignUnitsRoundRobin(expandGiftUnits(remaining), parents, byParent);

      byParent.forEach((list, id) => {
        byParent.set(id, collapseGiftItems(list));
      });
      return { byParent, leftovers: [] };
    }
  
    function getGiftCompareCents(item) {
      const sale = getLineItemUnitSaleCents(item);
      const compare = getLineItemUnitCompareCents(item, sale);
      if (compare > sale) return compare;
      const original = Number(item.original_price || 0);
      return original > sale ? original : 0;
    }
  
    function getRegularItems() {
      return getVisibleItems().filter((x) => !isGiftItem(x));
    }
  
    function hasDealClaimed() {
      const ids = getKnownDealVariantIds();
      if (!ids.size) return false;
      return Boolean(state.cart?.items?.some((item) => ids.has(Number(item.variant_id))));
    }
  
    function getDealCartItem() {
      return findDealCartItem();
    }
  
    function buildVehicleMeta(item) {
      const entries = Object.entries(item.properties || {}).filter(([k, v]) => {
        return !k.startsWith("_") && String(v || "").trim().length > 0;
      });
      return entries.slice(0, 3).map(([k, v]) => `${k} : ${v}`);
    }
  
    function isDefaultVariantTitle(value) {
      return String(value || "").trim().toLowerCase() === "default title";
    }
  
    function getLineItemVariantText(item) {
      const title = String(item?.variant_title || "").trim();
      if (title && !isDefaultVariantTitle(title)) return title;
  
      const fromOptions = (item?.options_with_values || [])
        .map((option) => String(option?.value || "").trim())
        .filter((value) => value && !isDefaultVariantTitle(value));
      return fromOptions.length ? fromOptions.join(" / ") : "";
    }
  
    function renderLineItemDiscountCodes(item, options = {}) {
      const pricingOptions = options.bundleMode ? { forceBundle: true } : {};
      const upsell = getPremiumCartUpsellDisplayPricing(item, pricingOptions);
      if (upsell?.discountLabel) {
        const kind = upsell.offerMode === "individual" ? "individual" : "bundle";
        return `<span class="SCS_CART_02__discount-code SCS_CART_02__discount-code--${kind}">${htmlEscape(upsell.discountLabel)}</span>`;
      }
      if (isPremiumCartUpsellLine(item) && !cartHasLuxurySeatCover()) return "";
      const titles = getLineItemDiscountTitles(item).filter((title) => !isCartSummaryCoupon(title));
      if (!titles.length) return "";
      return titles.map((title) => `<span class="SCS_CART_02__discount-code">${htmlEscape(title)}</span>`).join("");
    }

    function getLineItemColor(item) {
      const option = (item?.options_with_values || []).find((o) => o?.name === "Color");
      return option ? String(option.value || "").trim() : "";
    }

    function getLineItemProp(item, key) {
      const props = item?.properties && typeof item.properties === "object" ? item.properties : {};
      if (props[key] != null && String(props[key]).trim()) return String(props[key]).trim();
      const lower = key.toLowerCase();
      for (const k in props) {
        if (k.toLowerCase() === lower && props[k] != null && String(props[k]).trim()) {
          return String(props[k]).trim();
        }
      }
      return "";
    }

    // Main seat-cover line added by the empty-cart configurator (has _seat +
    // a vehicle label, and is not a GWP bonus line) — gates the Edit row.
    function isEditableSeatCoverLine(item) {
      if (getLineItemProp(item, "_bonus_type")) return false;
      // Custom 2nd/3rd Row add-on line — separately-shipped extra, not the
      // configurable main line; it carries _seat/Your Vehicle too (for
      // display), so it must be excluded explicitly, not inferred from those.
      if (getLineItemProp(item, "_custom_rear")) return false;
      if (!getLineItemProp(item, "_seat")) return false;
      if (!getLineItemProp(item, "Your Vehicle") && !getLineItemProp(item, "_your_vehicle")) return false;
      return true;
    }

    function renderLineEditBtn(item) {
      if (window.scs_cart_02_edit_fnc !== true) return "";
      if (!isEditableSeatCoverLine(item)) return "";
      const lineKey = htmlEscape(String(item.key || item.id || ""));
      return `<button type="button" class="SCS_CART_02__edit-btn" data-action="edit-line" data-aspect="setup" data-line-key="${lineKey}" aria-label="Edit item">${ICON_SVG.edit}</button>`;
    }

    function renderLineItemShipBy(item) {
      if (!window.SCSShipBy) return "";
      const color = getLineItemColor(item);
      if (!color) return "";
      const props = item.properties || {};
      const shipByText = window.SCSShipBy.getShipByText(color, props._components, props._part_no || props._new_sku);
      if (!shipByText) return "";
      return `<p class="SCS_CART_02__ship-by">Your order will ship by <strong>${htmlEscape(shipByText)}</strong></p>`;
    }

    function renderLineItem(item, options = {}) {
      const line = getLineNumber(item);
      const pricingOptions = options.bundleMode ? { forceBundle: true } : {};
      const unitSale = getLineItemUnitSaleCents(item, pricingOptions);
      const unitCompare = getLineItemUnitCompareCents(item, unitSale, pricingOptions);
      const meta = buildVehicleMeta(item);
      const variantText = getLineItemVariantText(item);
      const discountCodesHtml = renderLineItemDiscountCodes(item, options);
      const shipByHtml = renderLineItemShipBy(item);
      const editBtnHtml = renderLineEditBtn(item);
      const nestedGifts = Array.isArray(options.nestedGifts) ? options.nestedGifts : [];
      const bundleItemClass =
        options.bundleMode ? " SCS_CART_02__line-item--premium-bundle" : "";
      const nestedGiftsHtml = renderNestedGifts(nestedGifts);

      const plusLabel = "Increase quantity";
      const variantId = String(item.variant_id ?? item.id ?? "");
      const imgSrc = htmlEscape(item.image || item.featured_image?.url || "");
      const imgAlt = htmlEscape(item.product_title);
      const imageHtml = isPremiumCartUpsellLine(item)
        ? `<button type="button" class="SCS_CART_02__line-item-img-btn" data-action="open-upsell-detail" data-variant-id="${htmlEscape(variantId)}" aria-label="More details about ${imgAlt}">
            <img class="SCS_CART_02__line-item-img" src="${imgSrc}" alt="${imgAlt}">
          </button>`
        : `<img class="SCS_CART_02__line-item-img" src="${imgSrc}" alt="${imgAlt}">`;

      return `
        <div class="SCS_CART_02__line-block${nestedGifts.length ? " SCS_CART_02__line-block--has-gifts" : ""}">
          <article class="SCS_CART_02__line-item${bundleItemClass}" data-line="${line}">
            ${imageHtml}
            <div class="SCS_CART_02__line-item-main">
              <div class="SCS_CART_02__title-row">
                <div class="SCS_CART_02__title-group">
                  <p class="SCS_CART_02__name">${htmlEscape(item.product_title)}</p>
                  ${discountCodesHtml}
                </div>
                <div class="SCS_CART_02__title-actions">
                  <button type="button" class="SCS_CART_02__remove-btn" data-action="remove-line" data-line="${line}" aria-label="Remove item">${ICON_SVG.trash}</button>
                </div>
              </div>
              ${variantText || editBtnHtml ? `<div class="SCS_CART_02__variant-row">${variantText ? `<p class="SCS_CART_02__variant">${htmlEscape(variantText)}</p>` : ""}${editBtnHtml}</div>` : ""}
              ${meta.length ? `<div class="SCS_CART_02__meta">${meta.map((entry) => `<span>${htmlEscape(entry)}</span>`).join("")}</div>` : ""}
              <div class="SCS_CART_02__line-bottom">
                <div class="SCS_CART_02__qty">
                  <button type="button" class="SCS_CART_02__qty-btn SCS_CART_02__qty-btn--minus" data-action="qty-down" data-line="${line}" aria-label="${item.quantity > 1 ? "Decrease quantity" : "Remove item"}">${ICON_SVG.minus}</button>
                  <strong class="SCS_CART_02__qty-val">${item.quantity}</strong>
                  <button type="button" class="SCS_CART_02__qty-btn SCS_CART_02__qty-btn--plus" data-action="qty-up" data-line="${line}" aria-label="${plusLabel}">${ICON_SVG.plus}</button>
                </div>
                <div class="SCS_CART_02__price-col">

                  ${unitCompare > unitSale ? `<span class="SCS_CART_02__compare">${toMoney(unitCompare)}</span>` : ""}
                  <span class="SCS_CART_02__sale">${toMoney(unitSale)}</span>
                </div>
              </div>
              ${shipByHtml}
            </div>
          </article>
          ${nestedGiftsHtml}
        </div>
      `;
    }

    function getGiftDisplayName(item) {
      const title = String(item?.product_title || "").trim();
      if (item?.isBundle) return title;
      const variant = getLineItemVariantText(item);
      if (!variant) return title;
      if (title.toLowerCase().includes(variant.toLowerCase())) return title;
      return `${title} · ${variant}`;
    }

    function renderNestedGift(item) {
      const img = item.image || item.featured_image?.url || "";
      const compareVal = item.compareCents || 0;
      const qty = item.quantity || 1;
      const displayName = getGiftDisplayName(item);
      const qtyPrefix = qty > 1 ? `${qty}× ` : "";

      return `
        <div class="SCS_CART_02__nested-gift">
          ${
            img
              ? `<img class="SCS_CART_02__nested-gift-img" src="${htmlEscape(img)}" alt="${htmlEscape(displayName)}">`
              : `<span class="SCS_CART_02__nested-gift-img SCS_CART_02__nested-gift-img--empty" aria-hidden="true"></span>`
          }
          <p class="SCS_CART_02__nested-gift-name">${htmlEscape(qtyPrefix + displayName)}</p>
          <div class="SCS_CART_02__nested-gift-price">
            ${compareVal > 0 ? `<span class="SCS_CART_02__nested-gift-compare">${toMoney(compareVal)}</span>` : ""}
            <span class="SCS_CART_02__nested-gift-free">FREE</span>
          </div>
        </div>
      `;
    }

    function renderNestedGifts(gifts) {
      if (!gifts?.length) return "";
      return `<div class="SCS_CART_02__nested-gifts">${gifts.map(renderNestedGift).join("")}</div>`;
    }
  
    function renderShippingBanner() {
      const subtotal = getCartSubtotalCents();
      const unlocked = subtotal >= FREE_SHIPPING_THRESHOLD;
  
      if (unlocked) {
        return `
          <section class="SCS_CART_02__shipping-banner SCS_CART_02__shipping-banner--unlocked">
            <p class="SCS_CART_02__shipping-banner-headline">Good Choice! Your selection is being reserved.</p>
            <div class="SCS_CART_02__shipping-track"><div class="SCS_CART_02__shipping-bar"></div></div>
            <p class="SCS_CART_02__shipping-banner-text">Congrats! You Unlocked <strong>FREE Standard Shipping</strong></p>
          </section>`;
      }
  
      const away = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
      const progress = subtotal <= 0 ? 4 : Math.max(4, Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100)));
      return `
        <section class="SCS_CART_02__shipping-banner SCS_CART_02__shipping-banner--progress">
          <p class="SCS_CART_02__shipping-banner-headline">Good Choice! Your selection is being reserved.</p>
          <div class="SCS_CART_02__shipping-track"><div class="SCS_CART_02__shipping-bar" style="width:${progress}%"></div></div>
          <p class="SCS_CART_02__shipping-banner-sub">You are ${toMoney(away)} away from <strong>FREE SHIPPING</strong></p>
        </section>`;
    }
  
    function getUpsellFit(item) {
      if (item.uid in state.upsellFits) return state.upsellFits[item.uid];
      return item.isDeal ? (state.deal.fit || "car") : "car";
    }
  
    function getUpsellPricing(item) {
      if (!item.isDeal || !item.variants?.length) {
        return { price: item.price, compareAt: item.compareAt, variantId: item.variantId };
      }
      const fit = getUpsellFit(item);
      const variant = matchDealFitVariant(item.variants, fit);
      if (!variant) {
        return { price: item.price, compareAt: item.compareAt, variantId: item.variantId };
      }
      const pricing = syncDealVariantPricing(variant, fit);
      const variantId = Number(variant.id);
      if (getSeatItems().length === 0) {
        const listPrice = resolveRebuyVariantPrice(variant, { variants: item.variants });
        const compareAt = resolveRebuyVariantCompareAt(variant, { variants: item.variants }, listPrice);
        return { price: listPrice || pricing.sale, compareAt, variantId };
      }
      return { price: pricing.sale, compareAt: pricing.compareAt, variantId };
    }
  
    function applyUpsellFit(upsellId, fit) {
      if (!upsellId) return;
      state.upsellFits[upsellId] = fit || "car";

      const item = (state.recommendations || []).find((rec) => rec.uid === upsellId);
      const card = root
        ? [...root.querySelectorAll(".SCS_CART_02__upsell-card")].find((el) => el.dataset.upsellId === upsellId)
        : null;
      if (!item || !card) return;

      card.querySelectorAll(".SCS_CART_02__upsell-fit").forEach((btn) => {
        btn.classList.toggle("is-active", btn.dataset.fit === state.upsellFits[upsellId]);
      });

      const pricing = getUpsellPricing(item);
      const saleEl = card.querySelector(".SCS_CART_02__upsell-sale");
      const priceWrap = card.querySelector(".SCS_CART_02__upsell-price");
      let compareEl = card.querySelector(".SCS_CART_02__upsell-compare");
      if (saleEl) saleEl.textContent = toMoney(pricing.price);
      if (pricing.compareAt > pricing.price) {
        const compareText = toMoney(pricing.compareAt);
        if (compareEl) {
          compareEl.textContent = compareText;
        } else if (priceWrap) {
          priceWrap.insertAdjacentHTML(
            "beforeend",
            `<span class="SCS_CART_02__upsell-compare">${compareText}</span>`,
          );
        }
      } else if (compareEl) {
        compareEl.remove();
      }

      const addBtn = card.querySelector(".SCS_CART_02__upsell-add");
      if (addBtn && pricing.variantId) addBtn.dataset.variantId = String(pricing.variantId);
    }

    function renderUpsellFitRow(item) {
      if (!item.isDeal) return "";
      const carClass = getUpsellFit(item) === "car" ? "is-active" : "";
      const truckClass = getUpsellFit(item) === "truck" ? "is-active" : "";
      return `
        <div class="SCS_CART_02__upsell-fit-row">
          <button type="button" class="SCS_CART_02__upsell-fit ${carClass}" data-action="set-upsell-fit" data-upsell-id="${htmlEscape(item.uid)}" data-fit="car">
            <span class="SCS_CART_02__upsell-fit-radio" aria-hidden="true"></span>
            <span>Car or SUV</span>
          </button>
          <button type="button" class="SCS_CART_02__upsell-fit ${truckClass}" data-action="set-upsell-fit" data-upsell-id="${htmlEscape(item.uid)}" data-fit="truck">
            <span class="SCS_CART_02__upsell-fit-radio" aria-hidden="true"></span>
            <span>Truck</span>
          </button>
        </div>
      `;
    }
  
    function renderUpsellCard(item) {
      const pricing = getUpsellPricing(item);
      const compareHtml = pricing.compareAt > pricing.price
        ? `<span class="SCS_CART_02__upsell-compare">${toMoney(pricing.compareAt)}</span>`
        : "";
  
      return `
        <article class="SCS_CART_02__upsell-card" data-upsell-id="${htmlEscape(item.uid)}">
          <img class="SCS_CART_02__upsell-img" src="${htmlEscape(item.image)}" alt="${htmlEscape(item.title)}">
          <div class="SCS_CART_02__upsell-details">
            <p class="SCS_CART_02__upsell-name">${htmlEscape(item.title)}</p>
            ${renderUpsellFitRow(item)}
            <div class="SCS_CART_02__upsell-bottom">
              <p class="SCS_CART_02__upsell-price">
                <span class="SCS_CART_02__upsell-sale">${toMoney(pricing.price)}</span>
                ${compareHtml}
              </p>
              <button type="button" class="SCS_CART_02__upsell-add" data-action="add-upsell" data-variant-id="${pricing.variantId}" data-upsell-id="${htmlEscape(item.uid)}">Add</button>
            </div>
          </div>
        </article>
      `;
    }
  
    function getCartCompareCents(cart = state.cart) {
      if (!cart?.items?.length) return 0;
      let total = 0;
      for (const item of getVisibleItems()) {
        const qty = Number(item.quantity) || 1;
        const sale = getLineItemUnitSaleCents(item);
        const compare = getLineItemUnitCompareCents(item, sale);
        total += (compare > sale ? compare : sale) * qty;
      }
      return total;
    }

    function renderFooter() {
      if (!state.cart) return "";
      const cart = state.cart;
      const subtotal = cart.total_price || 0;
      const compareTotal = getCartCompareCents(cart);
      const itemLabel = cart.item_count === 1 ? "item" : "items";
      const summaryCoupons = getCartSummaryCoupons(cart);
      const discountRowsHtml = summaryCoupons.map((row) => `
          <div class="SCS_CART_02__discount-row">
            <span class="SCS_CART_02__discount-label">Discount (${htmlEscape(row.code)})</span>
            <span class="SCS_CART_02__discount-value">${toBadgeMoney(row.amountCents)} off</span>
          </div>
        `).join("");
  
      return `
        <div class="SCS_CART_02__checkout-summary">
          ${discountRowsHtml}
          <div class="SCS_CART_02__subtotal-row">
            <span class="SCS_CART_02__subtotal-label">Subtotal (${cart.item_count} ${itemLabel})</span>
            <div class="SCS_CART_02__subtotal-prices">
              
              ${compareTotal > subtotal ? `<span class="SCS_CART_02__subtotal-compare">${toMoney(compareTotal)}</span>` : ""}
              <span class="SCS_CART_02__subtotal-sale">${toMoney(subtotal)}</span>
            </div>
          </div>
        </div>
        <button type="button" class="SCS_CART_02__checkout-btn" data-action="checkout">
          <span>🔒 Continue Checkout</span>
          <svg class="SCS_CART_02__checkout-arrow" width="11" height="20" viewBox="0 0 11 20" fill="none" aria-hidden="true">
            <path d="M2 2L9 10L2 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="SCS_CART_02__badges">
          <img class="SCS_CART_02__badges-img SCS_CART_02__badges-img--desktop" src="${BADGE_DESKTOP}" alt="Payment security badges">
          <img class="SCS_CART_02__badges-img SCS_CART_02__badges-img--mobile" src="${BADGE_MOBILE}" alt="Payment security badges">
        </div>
      `;
    }
  
    function parseRebuyMoney(value) {
      if (value == null || value === "") return 0;
      if (typeof value === "number") return value > 1000 ? value : Math.round(value * 100);
      const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
      return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
    }
  
    function getRebuySelectedVariant(product) {
      if (product?.selected_variant?.id) return product.selected_variant;
      const explicitId = product?.variant_id || product?.variantId;
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      if (explicitId) {
        const match = variants.find((variant) => Number(variant.id) === Number(explicitId));
        if (match) return match;
      }
      return variants[0] || null;
    }
  
    function resolveRebuyVariantPrice(variant, product) {
      if (!variant) return 0;
      const fromVariant = parseRebuyMoney(variant.price);
      if (fromVariant) return fromVariant;
  
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      if (variant.id && variants.length) {
        const match = variants.find((entry) => Number(entry.id) === Number(variant.id));
        const fromMatch = parseRebuyMoney(match?.price);
        if (fromMatch) return fromMatch;
      }
  
      if (variants.length <= 1) {
        return parseRebuyMoney(variants[0]?.price ?? product?.price ?? product?.price_cents);
      }
  
      return 0;
    }
  
    function resolveRebuyVariantCompareAt(variant, product, salePrice) {
      if (!variant) return 0;
      let compareAt = parseRebuyMoney(variant.compare_at_price);
      if (!compareAt && variant.id && Array.isArray(product?.variants)) {
        const match = product.variants.find((entry) => Number(entry.id) === Number(variant.id));
        compareAt = parseRebuyMoney(match?.compare_at_price);
      }
      if (!compareAt && salePrice > 0) {
        compareAt = parseRebuyMoney(product?.compare_at_price);
      }
      return compareAt > salePrice ? compareAt : 0;
    }
  
    function getUpsellAddWidgetId(item) {
      if (item?.isDeal) return REBUY_DEAL_WIDGET_ID;
      return REBUY_UPSELL_WIDGET_ID;
    }
  
    function normalizeRebuyProduct(p, idx) {
      if (!p) return null;
      const isDeal = isDealCatalogRebuyProduct(p);
      let variants = [];
      if (isDeal) {
        const dealProduct = normalizeRebuyDealProduct(p);
        if (dealProduct?.variants?.length) {
          variants = dealProduct.variants;
          setDealProduct(dealProduct);
        }
      }
      const variant = getRebuySelectedVariant(p);
      const variantId = variant?.id || p.variant_id || p.variantId;
      const title = p.title || p.product_title || p.name;
      const image = p.image?.src || p.image || p.featured_image || p.images?.[0]?.src || p.image_url;
      if (!variantId || !title) return null;
      const price = resolveRebuyVariantPrice(variant, p);
      const compareAt = resolveRebuyVariantCompareAt(variant, p, price);
      return {
        uid: `${variantId}-${idx}`,
        variantId: Number(variantId),
        productId: Number(p.id || p.product_id || 0),
        title: String(title),
        image: typeof image === "string" ? image : image?.src || "",
        price,
        compareAt: compareAt > price ? compareAt : 0,
        isDeal,
        variants,
      };
    }
  
    function normalizeRebuyDealProduct(p) {
      if (!p) return null;
      const mapVariant = (variant) => ({
        id: variant.id,
        title: variant.title,
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3,
        public_title: variant.public_title,
        price: parseRebuyMoney(variant.price),
        compare_at_price: parseRebuyMoney(variant.compare_at_price),
      });
  
      let variants = Array.isArray(p.variants) ? p.variants.map(mapVariant).filter((v) => v.id) : [];
      if (!variants.length && p.selected_variant?.id) {
        variants = [mapVariant(p.selected_variant)];
      }
  
      const image = p.image?.src || p.image || p.featured_image || p.images?.[0]?.src || p.image_url;
      return {
        handle: p.handle || p.product_handle || "",
        title: p.title || p.product_title || p.name || "",
        featured_image: typeof image === "string" ? image : image?.src || "",
        variants,
      };
    }
  
    function syncDealFromRebuyWidget() {
      if (state.deal.product?.variants?.length) {
        syncDealFromProduct(state.deal.product);
        return true;
      }
  
      const widget = findRebuyWidget(REBUY_UPSELL_WIDGET_ID);
      if (!isConfiguredUpsellWidget(widget)) return false;
      applyCartContextToWidget(widget);
      const products = widget.data?.products;
      if (!Array.isArray(products) || !products.length) return false;
      const product = pickDealProductFromRebuyProducts(products);
      if (!product?.variants?.length) return false;
      setDealProduct(product);
      return true;
    }
  
    function getRebuyApiKey() {
      return cfg.rebuyApiKey || window.Rebuy?.shop?.api_key || window.Rebuy?.shop?.apiKey || "";
    }
  
    function isConfiguredUpsellWidget(widget) {
      return Boolean(widget && String(widget.id) === REBUY_UPSELL_WIDGET_ID);
    }
  
    function getRebuyRulesetId(widget) {
      if (!isConfiguredUpsellWidget(widget)) return "";
      return (
        cfg.rebuyRulesetId ||
        cfg.rebuyDataSourceId ||
        widget?.data?.metadata?.ruleset_id ||
        widget?.data?.settings?.ruleset_id ||
        widget?.data?.settings?.data_source_id ||
        ""
      );
    }
  
    function findRebuyWidget(widgetId = REBUY_UPSELL_WIDGET_ID) {
      const widgets = window.Rebuy?.widgets || [];
      return widgets.find((w) => String(w.id) === String(widgetId)) || null;
    }
  
    function ensureRebuyWidgetHost(widgetId = REBUY_UPSELL_WIDGET_ID) {
      if (!root) return null;
      let host = root.querySelector(`[data-rebuy-id="${widgetId}"]`);
      if (!host) {
        host = document.createElement("div");
        host.className = "SCS_CART_02__rebuy-host";
        host.setAttribute("data-rebuy-id", widgetId);
        host.setAttribute("aria-hidden", "true");
        host.hidden = true;
        root.appendChild(host);
        if (typeof window.Rebuy?.init === "function") {
          try {
            window.Rebuy.init();
          } catch (err) {
            console.warn("[SCS_CART_02] Rebuy.init failed:", err);
          }
        }
      }
      return host;
    }
  
    function getRebuyCartSignature() {
      return (state.cart?.items || []).map((item) => `${item.variant_id}:${item.quantity}`).join("|");
    }
  
    function bindRebuyWidgetWatcher(widget) {
      if (!widget || widget.__SCS_CART_02_WATCHING__) return;
      widget.__SCS_CART_02_WATCHING__ = true;
      if (typeof widget.watchCart !== "function") return;
      try {
        widget.watchCart(() => {
          syncRebuyFromWidget();
          scheduleCartRefreshFromRebuy();
        });
      } catch (err) {
        console.warn("[SCS_CART_02] widget.watchCart failed:", err);
      }
    }
  
    function waitForRebuyWidget(widgetId = REBUY_UPSELL_WIDGET_ID, timeout = 8000) {
      return new Promise((resolve) => {
        const immediate = findRebuyWidget(widgetId);
        if (immediate) {
          if (String(widgetId) === REBUY_UPSELL_WIDGET_ID) bindRebuyWidgetWatcher(immediate);
          resolve(immediate);
          return;
        }
  
        if (String(widgetId) === REBUY_UPSELL_WIDGET_ID) ensureRebuyWidgetHost(widgetId);
  
        let settled = false;
        const finish = (widget) => {
          if (settled) return;
          settled = true;
          document.removeEventListener("rebuy.ready", onReady);
          clearInterval(poll);
          clearTimeout(timer);
          if (widget) {
            if (String(widgetId) === REBUY_UPSELL_WIDGET_ID) bindRebuyWidgetWatcher(widget);
          }
          resolve(widget || null);
        };
  
        const onReady = (event) => {
          const widget = event.detail?.widget;
          if (widget && String(widget.id) === String(widgetId)) finish(widget);
        };
  
        document.addEventListener("rebuy.ready", onReady);
        const poll = setInterval(() => {
          const widget = findRebuyWidget(widgetId);
          if (widget) finish(widget);
        }, 250);
        const timer = setTimeout(() => finish(findRebuyWidget(widgetId)), timeout);
      });
    }
  
    function applyCartContextToWidget(widget) {
      if (!widget?.data || !state.cart?.items?.length) return;
      widget.data.shopify_variant_ids = state.cart.items.map((item) => item.variant_id).filter(Boolean);
      widget.data.shopify_product_ids = state.cart.items.map((item) => item.product_id).filter(Boolean);
    }
  
    function fetchProductsFromWidget(widget, timeoutMs = 5000) {
      return new Promise((resolve) => {
        if (!isConfiguredUpsellWidget(widget)) {
          resolve([]);
          return;
        }
        applyCartContextToWidget(widget);
        const existing = widget.data?.products;
        if (typeof widget.getWidgetProducts !== "function") {
          resolve(Array.isArray(existing) ? existing : []);
          return;
        }
        let settled = false;
        const finish = (products) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(Array.isArray(products) ? products : []);
        };
        const timer = setTimeout(() => finish(widget.data?.products || existing || []), timeoutMs);
        try {
          widget.getWidgetProducts(() => {
            finish(widget.data?.products || existing || []);
          });
        } catch (err) {
          console.warn("[SCS_CART_02] getWidgetProducts failed:", err);
          finish(existing || []);
        }
      });
    }
  
    async function fetchProductsFromRebuyApi(widget) {
      if (!isConfiguredUpsellWidget(widget)) return [];
  
      const apiKey = getRebuyApiKey();
      const rulesetId = getRebuyRulesetId(widget);
      if (!apiKey || !rulesetId) return [];
  
      const params = new URLSearchParams({
        key: apiKey,
        limit: String(cfg.rebuyLimit || 8),
        filter_oos: "yes",
        widget_id: REBUY_UPSELL_WIDGET_ID,
      });
  
      const cart = state.cart;
      if (cart?.items?.length) {
        cart.items.forEach((item, i) => {
          params.append(`cart[items][${i}][product_id]`, String(item.product_id));
          params.append(`cart[items][${i}][variant_id]`, String(item.variant_id));
          params.append(`cart[items][${i}][quantity]`, String(item.quantity));
        });
        const variantIds = cart.items.map((item) => item.variant_id).filter(Boolean).join(",");
        if (variantIds) params.set("shopify_variant_ids", variantIds);
      }
  
      const url = `https://rebuyengine.com/api/v1/custom/id/${rulesetId}?${params}`;
  
      try {
        const res = await fetch(url, { credentials: "omit" });
        if (!res.ok) return [];
        const json = await res.json();
        return json.data || [];
      } catch (err) {
        console.warn("[SCS_CART_02] Rebuy API fetch failed:", err);
        return [];
      }
    }
  
    function clearUpsellRecommendations() {
      state.recommendations = [];
      state.rebuyLoading = false;
      syncUpsellSection();
    }
  
    function applyRebuyRecommendations(products) {
      const cartProductIds = new Set((state.cart?.items || []).map((item) => Number(item.product_id)).filter(Boolean));
      const cartVariantIds = getExcludedUpsellVariantIds();
      const seenProductIds = new Set();
  
      state.recommendations = products
        .filter((p) => !isUpsellExcludedRebuyProduct(p))
        .map((p, i) => normalizeRebuyProduct(p, i))
        .filter(Boolean)
        .filter((item) => {
          if (item.productId) {
            if (cartProductIds.has(item.productId)) return false;
            if (seenProductIds.has(item.productId)) return false;
            seenProductIds.add(item.productId);
          }
          return !cartVariantIds.has(item.variantId);
        })
        .slice(0, cfg.rebuyLimit || 8);
    }
  
    function hydrateRebuyRecommendationsFallback() {
      if (!syncRebuyFromWidget()) clearUpsellRecommendations();
    }
  
    function syncRebuyFromWidget() {
      const widget = findRebuyWidget(REBUY_UPSELL_WIDGET_ID);
      if (!isConfiguredUpsellWidget(widget)) {
        return false;
      }
      applyCartContextToWidget(widget);
      const products = widget.data?.products;
      if (!Array.isArray(products) || !products.length) {
        return false;
      }
      applyRebuyRecommendations(products);
      state.rebuyLoading = false;
      syncUpsellSection();
      return state.recommendations.length > 0;
    }
  
    function syncUpsellSection() {
      if (!refs?.body || !state.cart?.items?.length) return;
      const html = renderUpsellSection();
      const existing = refs.body.querySelector(".SCS_CART_02__upsell");
      if (!html) {
        existing?.remove();
      } else if (existing) {
        existing.outerHTML = html;
      } else {
        refs.body.insertAdjacentHTML("beforeend", html);
      }
      lastRenderKey = getRenderKey();
    }
  
    function scheduleRebuyLoad(options = {}) {
      const force = options.force === true;
      const cartSig = getRebuyCartSignature();
      if (cartSig !== rebuyCartSignature) {
        rebuyCartSignature = cartSig;
        rebuyFetchPromise = null;
        rebuyLoadGeneration += 1;
        state.recommendations = [];
      }
  
      if (syncRebuyFromWidget()) {
        if (!force && state.recommendations.length) {
          if (!rebuyFetchPromise) {
            rebuyFetchPromise = loadRebuyRecommendations({ background: true }).finally(() => {
              rebuyFetchPromise = null;
            });
          }
          return rebuyFetchPromise;
        }
      }
  
      const showSkeleton = options.showSkeleton !== false && !state.recommendations.length;
  
      if (!force && state.recommendations.length) {
        if (rebuyFetchPromise) return rebuyFetchPromise;
        rebuyFetchPromise = loadRebuyRecommendations({ background: true }).finally(() => {
          rebuyFetchPromise = null;
        });
        return rebuyFetchPromise;
      }
  
      if (rebuyFetchPromise) return rebuyFetchPromise;
  
      if (showSkeleton) {
        state.rebuyLoading = true;
        syncUpsellSection();
      }
  
      rebuyFetchPromise = loadRebuyRecommendations({ showSkeleton }).finally(() => {
        rebuyFetchPromise = null;
      });
  
      if (showSkeleton) {
        const loadToken = rebuyLoadGeneration;
        setTimeout(() => {
          if (loadToken !== rebuyLoadGeneration) return;
          if (!state.rebuyLoading || state.recommendations.length) return;
          state.rebuyLoading = false;
          syncUpsellSection();
        }, 12000);
      }
  
      return rebuyFetchPromise;
    }
  
    function prefetchRebuy() {
      ensureRebuyWidgetHost(REBUY_UPSELL_WIDGET_ID);
      void waitForRebuyWidget(REBUY_UPSELL_WIDGET_ID, 8000).then((widget) => {
        if (widget && state.cart) scheduleRebuyLoad({ force: true, showSkeleton: !state.recommendations.length });
      });
    }
  
    async function loadRebuyRecommendations(options = {}) {
      const background = options.background === true;
      const generation = rebuyLoadGeneration;
  
      const finishRebuyLoad = () => {
        if (generation !== rebuyLoadGeneration) return;
        state.rebuyLoading = false;
        syncUpsellSection();
      };
  
      const applyWidgetProducts = (products) => {
        if (generation !== rebuyLoadGeneration) return;
        if (products.length) applyRebuyRecommendations(products);
        else clearUpsellRecommendations();
      };
  
      if (background && state.recommendations.length) {
        try {
          let products = [];
          const widget = await waitForRebuyWidget(REBUY_UPSELL_WIDGET_ID, 4000);
          if (generation !== rebuyLoadGeneration) return;
          if (!isConfiguredUpsellWidget(widget)) {
            clearUpsellRecommendations();
            return;
          }
          if (widget) products = await fetchProductsFromWidget(widget);
          if (!products.length) products = await fetchProductsFromRebuyApi(widget);
          if (generation !== rebuyLoadGeneration) return;
          applyWidgetProducts(products);
        } catch (err) {
          console.warn("[SCS_CART_02] background rebuy refresh failed:", err);
        } finally {
          if (generation === rebuyLoadGeneration) syncUpsellSection();
        }
        return;
      }
  
      try {
        let products = [];
        const widget = await waitForRebuyWidget(REBUY_UPSELL_WIDGET_ID);
        if (generation !== rebuyLoadGeneration) return;
        if (!isConfiguredUpsellWidget(widget)) {
          clearUpsellRecommendations();
          return;
        }
        if (widget) products = await fetchProductsFromWidget(widget);
        if (generation !== rebuyLoadGeneration) return;
        if (!products.length) products = await fetchProductsFromRebuyApi(widget);
        if (generation !== rebuyLoadGeneration) return;
        if (!products.length) hydrateRebuyRecommendationsFallback();
        else applyWidgetProducts(products);
      } catch (err) {
        console.warn("[SCS_CART_02] loadRebuyRecommendations failed:", err);
        if (generation === rebuyLoadGeneration) hydrateRebuyRecommendationsFallback();
      } finally {
        finishRebuyLoad();
      }
    }
  
    function scrollUpsellCarousel(dir) {
      const track = root?.querySelector("#SCS_CART_02_upsell-track");
      if (!track) return;
      const card = track.querySelector(".SCS_CART_02__upsell-card");
      const gap = 15;
      const step = card ? card.offsetWidth + gap : Math.round(track.clientWidth * 0.85);
      track.scrollBy({ left: dir * step, behavior: "smooth" });
    }
  
    function setUpsellLoading(btn, loading) {
      if (!btn) return;
      if (loading) {
        if (!btn.dataset.scsUpsellContent) btn.dataset.scsUpsellContent = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add("is-loading");
        btn.innerHTML = '<span class="SCS_CART_02__upsell-spinner" aria-hidden="true"></span>';
        return;
      }
      btn.disabled = false;
      btn.classList.remove("is-loading");
      if (btn.dataset.scsUpsellContent) {
        btn.innerHTML = btn.dataset.scsUpsellContent;
        delete btn.dataset.scsUpsellContent;
      }
    }
  
    function renderUpsellSection() {
      if (state.rebuyLoading && !state.recommendations.length) {
        return `
          <section class="SCS_CART_02__upsell">
            <h2 class="SCS_CART_02__upsell-title">You May Also Like</h2>
            <div class="SCS_CART_02__upsell-skeleton" aria-hidden="true">
              <div class="SCS_CART_02__skeleton-img"></div>
              <div class="SCS_CART_02__skeleton-lines">
                <div class="SCS_CART_02__skeleton-line SCS_CART_02__skeleton-line--title"></div>
                <div class="SCS_CART_02__skeleton-line"></div>
              </div>
            </div>
          </section>`;
      }
  
      if (!state.recommendations.length) return "";
  
      const cards = state.recommendations.map((item) => renderUpsellCard(item)).join("");
      const nav =
        state.recommendations.length > 1
          ? `
        <div class="SCS_CART_02__carousel-nav">
          <button type="button" class="SCS_CART_02__carousel-btn" data-action="upsell-prev" aria-label="Previous recommendation">&#8249;</button>
          <button type="button" class="SCS_CART_02__carousel-btn" data-action="upsell-next" aria-label="Next recommendation">&#8250;</button>
        </div>`
          : "";
  
      return `
        <section class="SCS_CART_02__upsell">
          <div class="SCS_CART_02__upsell-header">
            <h2 class="SCS_CART_02__upsell-title">You May Also Like</h2>
            ${nav}
          </div>
          <div class="SCS_CART_02__upsell-track" id="SCS_CART_02_upsell-track">${cards}</div>
        </section>`;
    }
  
    function getRenderKey() {
      const cart = state.cart;
      if (!cart) return `loading:${state.loading}`;
      const itemsKey = (cart.items || []).map((item) => {
        const sale = getLineItemUnitSaleCents(item);
        const compare = getLineItemUnitCompareCents(item, sale);
        const discounts = getLineItemDiscountTitles(item).join(",");
        return `${item.key}:${item.quantity}:${sale}:${compare}:${discounts}`;
      }).join("|");
      return [
        cart.item_count,
        cart.total_price,
        cart.original_total_price,
        cart.total_discount,
        itemsKey,
        getCartSummaryCoupons(cart).map((row) => `${row.code}:${row.amountCents}`).join(","),
        JSON.stringify(state.upsellFits),
        getSeatItems().length,
        state.recommendations.length,
        state.rebuyLoading,
      ].join("::");
    }
  
    function renderSkeleton() {
      refs.title.textContent = "Your Cart";
      refs.body.innerHTML = `
        <div class="SCS_CART_02__skeleton" aria-hidden="true">
          <div class="SCS_CART_02__skeleton-banner"></div>
          ${[1, 2].map(() => `
            <div class="SCS_CART_02__skeleton-item">
              <div class="SCS_CART_02__skeleton-img"></div>
              <div class="SCS_CART_02__skeleton-lines">
                <div class="SCS_CART_02__skeleton-line SCS_CART_02__skeleton-line--title"></div>
                <div class="SCS_CART_02__skeleton-line"></div>
                <div class="SCS_CART_02__skeleton-line SCS_CART_02__skeleton-line--short"></div>
                <div class="SCS_CART_02__skeleton-stepper"></div>
              </div>
            </div>
          `).join("")}
        </div>`;
      refs.footer.innerHTML = `
        <div class="SCS_CART_02__skeleton-footer">
          <div class="SCS_CART_02__skeleton-line SCS_CART_02__skeleton-line--footer"></div>
          <div class="SCS_CART_02__skeleton-checkout"></div>
        </div>`;
      setRefreshUi();
    }
  
    function render(force = false) {
      if (!refs) return;
  
      if (shouldShowCartSkeleton()) {
        if (!force && lastRenderKey === "__skeleton__") return;
        lastRenderKey = "__skeleton__";
        renderSkeleton();
        return;
      }
  
      const cart = state.cart;
      if (!cart || !cart.items || cart.items.length === 0) {
        const emptyKey = "empty";
        if (!force && lastRenderKey === emptyKey) {
          setRefreshUi();
          return;
        }
        lastRenderKey = emptyKey;
        refs.title.textContent = "Your Cart";
        refs.body.innerHTML = '<p class="SCS_CART_02__empty">Your cart is empty.</p>';
        refs.footer.innerHTML = '<div class="SCS_CART_02__empty-block"></div>';
        setRefreshUi();
        return;
      }
  
      const renderKey = getRenderKey();
      if (!force && renderKey === lastRenderKey) {
        setRefreshUi();
        return;
      }
      lastRenderKey = renderKey;
  
      const regular = getRegularItems();
      const {
        bundleState,
        upsellBundle,
        upsellIndividual,
        seatCovers,
        others,
      } = partitionRegularLineItems(regular);
      const { byParent, leftovers } = getGiftsByParent(seatCovers);

      let leftoverGifts = leftovers;
      const takeLeftoverGifts = () => {
        if (!leftoverGifts.length) return [];
        const gifts = leftoverGifts;
        leftoverGifts = [];
        return gifts;
      };

      const lineItemsHtml = [
        ...seatCovers.map((item) =>
          renderLineItem(item, { nestedGifts: byParent.get(getLineIdentity(item)) || [] }),
        ),
        renderPremiumUpsellBundleGroup(bundleState),
        ...upsellIndividual.map((item, index) =>
          renderLineItem(item, { nestedGifts: index === 0 ? takeLeftoverGifts() : [] }),
        ),
        ...others.map((item, index) =>
          renderLineItem(item, {
            nestedGifts: !upsellIndividual.length && index === 0 ? takeLeftoverGifts() : [],
          }),
        ),
      ].join("");
      const orphanGiftsHtml = leftoverGifts.length ? renderNestedGifts(leftoverGifts) : "";
  
      refs.title.textContent = "Your Cart";
      const prevWindowX = window.scrollX;
      const prevWindowY = window.scrollY;
      const prevScroll = refs.body?.scrollTop || 0;
      const prevTrackScroll = root?.querySelector("#SCS_CART_02_upsell-track")?.scrollLeft || 0;
      if (root?.contains(document.activeElement) && typeof document.activeElement.blur === "function") {
        document.activeElement.blur();
      }
      refs.body.innerHTML = `
        <div class="SCS_CART_02__main">
          ${renderShippingBanner()}
          ${
            lineItemsHtml
              ? `<div class="SCS_CART_02__line-items">${lineItemsHtml}</div>`
              : ""
          }
          ${orphanGiftsHtml}
          ${renderUpsellSection()}
        </div>
      `;
      refs.footer.innerHTML = renderFooter();
      const restoreScroll = () => {
        window.scrollTo(prevWindowX, prevWindowY);
        if (refs.body) refs.body.scrollTop = prevScroll;
        const track = root?.querySelector("#SCS_CART_02_upsell-track");
        if (track) track.scrollLeft = prevTrackScroll;
      };
      restoreScroll();
      requestAnimationFrame(restoreScroll);
      applyAugustOfferUpsellHide();
      setRefreshUi();
    }
  
    function showToast(message) {
      const current = document.querySelector(".SCS_CART_02__toast");
      if (current) current.remove();
      const el = document.createElement("div");
      el.className = "SCS_CART_02__toast";
      el.textContent = message;
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 2500);
    }
  
    const BODY_OPEN_CLASS = "scs-cart-02-open";
    const MICRO_APP_SELECTOR = ".rp-micro-app-dummy-icon-container";
    const microAppZIndexState = new WeakMap();
  
    function setMicroAppLayer(open) {
      document.querySelectorAll(MICRO_APP_SELECTOR).forEach((el) => {
        if (open) {
          if (!microAppZIndexState.has(el)) {
            microAppZIndexState.set(el, {
              inline: el.style.zIndex,
              priority: el.style.getPropertyPriority("z-index"),
              computed: window.getComputedStyle(el).zIndex,
            });
          }
          el.style.setProperty("z-index", "0", "important");
          return;
        }
  
        if (!microAppZIndexState.has(el)) return;
        const prev = microAppZIndexState.get(el);
        if (prev.inline) {
          el.style.setProperty("z-index", prev.inline, prev.priority || "");
        } else {
          el.style.removeProperty("z-index");
        }
        microAppZIndexState.delete(el);
      });
    }
  
    function openCart() {
      if (!root) return;
      root.classList.remove("is-closed");
      root.classList.add("is-open");
      document.body.classList.add(BODY_OPEN_CLASS);
      document.body.classList.add("overflow-hidden");
      document.body.style.overflow = "hidden";
      setMicroAppLayer(true);
    }
  
    function closeCart() {
      if (!root) return;
      closingCart = true;
      root.classList.add("is-closed");
      root.classList.remove("is-open");
      document.body.classList.remove(BODY_OPEN_CLASS);
      document.body.classList.remove("overflow-hidden");
      document.body.style.overflow = "";
      setMicroAppLayer(false);
      setTimeout(() => {
        closingCart = false;
      }, 0);
    }
  
    const CART_TRIGGER_SELECTOR = [
      "#cart-icon-bubble",
      ".header__icon--cart",
      "[data-cart-open]",
      "[aria-controls='CartDrawer']",
      "a[href*='/cart']",
    ].join(",");
  
    function isCartTrigger(trigger) {
      if (!trigger || !root || root.contains(trigger)) return false;
      if (trigger.matches("#cart-icon-bubble, .header__icon--cart, [data-cart-open], [aria-controls='CartDrawer']")) {
        return true;
      }
      if (trigger.matches("a[href*='/cart']")) {
        return Boolean(
          trigger.closest("header, .header, sticky-header, #shopify-section-header, .shopify-section-header")
        );
      }
      return false;
    }
  
    let openingCart = false;
  
    async function openCartAndRefresh() {
      if (openingCart || !root) return;
      openingCart = true;
      closeNativeCart();
  
      const hasCart = cartHasVisibleItems();
      if (!hasCart) {
        state.loading = true;
        render(true);
      }
  
      openCart();
  
      try {
        await fetchCart({ silent: hasCart });
      } finally {
        openingCart = false;
      }
    }
  
    function handleCartTriggerEvent(event) {
      const trigger = event.target.closest(CART_TRIGGER_SELECTOR);
      if (!isCartTrigger(trigger)) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openCartAndRefresh();
    }
  
    const CART_TRIGGER_EVENTS = ["mousedown", "click", "pointerup", "touchend"];
  
    function bindCartTriggerElement(el) {
      if (!el || el.dataset.scsCart02Bound === "1" || root.contains(el)) return;
      el.dataset.scsCart02Bound = "1";
      CART_TRIGGER_EVENTS.forEach((type) => {
        el.addEventListener(type, handleCartTriggerEvent, true);
      });
    }
  
    function bindCartTriggerElements() {
      document.querySelectorAll("#cart-icon-bubble, .header__icon--cart, [data-cart-open]").forEach(bindCartTriggerElement);
      document.querySelectorAll("a[href*='/cart']").forEach((el) => {
        if (isCartTrigger(el)) bindCartTriggerElement(el);
      });
    }
  
    function bindGlobalCartTriggers() {
      CART_TRIGGER_EVENTS.forEach((type) => {
        document.addEventListener(type, handleCartTriggerEvent, true);
      });
      bindCartTriggerElements();
      const triggerObserver = new MutationObserver(bindCartTriggerElements);
      if (document.body) {
        triggerObserver.observe(document.body, { childList: true, subtree: true });
      }
    }
  
    function hideNativeCart() {
      [
        "cart-drawer",
        "#CartDrawer",
        ".cart-drawer",
        "cart-notification",
        "#cart-notification",
        "#rebuy-cart",
        ".rebuy-cart",
      ].forEach((selector) => {
        document.querySelectorAll(selector).forEach((node) => {
          if (!root.contains(node)) {
            node.style.setProperty("display", "none", "important");
            node.style.setProperty("visibility", "hidden", "important");
            node.style.setProperty("pointer-events", "none", "important");
          }
        });
      });
    }
  
    function closeNativeCart() {
      hideNativeCart();
      try {
        window.Rebuy?.SmartCart?.hide?.();
      } catch (err) {
        console.error(err);
      }
      document.querySelectorAll("cart-drawer").forEach((drawer) => {
        if (drawer.__SCS_CART_02_NATIVE_CLOSE__) {
          drawer.__SCS_CART_02_NATIVE_CLOSE__.call(drawer);
        } else if (typeof drawer.close === "function") {
          drawer.close();
        }
        drawer.classList.remove("active");
        drawer.removeAttribute("open");
      });
    }
  
    function hijackNativeCartDrawer() {
      const patchDrawer = (drawer) => {
        if (!drawer || drawer.__SCS_CART_02_DRAWER_PATCHED__) return;
        drawer.__SCS_CART_02_DRAWER_PATCHED__ = true;
  
        if (typeof drawer.open === "function" && !drawer.__SCS_CART_02_NATIVE_OPEN__) {
          drawer.__SCS_CART_02_NATIVE_OPEN__ = drawer.open.bind(drawer);
          drawer.open = () => {
            closeNativeCart();
            openCartAndRefresh();
          };
        }
  
        if (typeof drawer.close === "function" && !drawer.__SCS_CART_02_NATIVE_CLOSE__) {
          drawer.__SCS_CART_02_NATIVE_CLOSE__ = drawer.close.bind(drawer);
          drawer.close = (...args) => {
            drawer.__SCS_CART_02_NATIVE_CLOSE__(...args);
            if (root?.classList.contains("is-open")) closeCart();
          };
        }
      };
  
      document.querySelectorAll("cart-drawer").forEach(patchDrawer);
      const drawerObserver = new MutationObserver(() => {
        document.querySelectorAll("cart-drawer").forEach(patchDrawer);
      });
      if (document.body) {
        drawerObserver.observe(document.body, { childList: true, subtree: true });
      }
    }
  
    function watchBodyOverflowTrap() {
      const rescueOpen = () => {
        if (closingCart || bootstrapping || !root) return;
        if (!document.body.classList.contains("overflow-hidden")) return;
        if (root.classList.contains("is-open")) return;
        closeNativeCart();
        openCartAndRefresh();
      };
  
      const observer = new MutationObserver(rescueOpen);
      observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    }
  
    function hijackRebuySmartCart() {
      const patch = () => {
        const smartCart = window.Rebuy?.SmartCart;
        if (!smartCart || smartCart.__SCS_CART_02_PATCHED__) return;
        smartCart.__SCS_CART_02_PATCHED__ = true;
        smartCart.show = () => {
          closeNativeCart();
          if (!bootstrapping) openCartAndRefresh();
        };
      };
  
      patch();
      const wait = (attempts = 40) => {
        patch();
        if (!window.Rebuy?.SmartCart?.__SCS_CART_02_PATCHED__ && attempts > 0) {
          setTimeout(() => wait(attempts - 1), 250);
        }
      };
      wait();
  
      document.addEventListener(
        "rebuy:smartcart.show",
        () => {
          closeNativeCart();
          if (!bootstrapping) openCartAndRefresh();
        },
        true
      );
    }
  
    function bindRebuyEvents() {
      if (window.__SCS_CART_02_REBUY_BOUND__) return;
      window.__SCS_CART_02_REBUY_BOUND__ = true;
  
      const onRebuyProductsReady = () => {
        if (syncRebuyFromWidget()) return;
        scheduleRebuyLoad({ force: true, showSkeleton: !state.recommendations.length });
      };
  
      document.addEventListener("rebuy.ready", (event) => {
        const widget = event.detail?.widget;
        if (!widget) return;
        const id = String(widget.id);
        if (id === REBUY_UPSELL_WIDGET_ID) {
          bindRebuyWidgetWatcher(widget);
          onRebuyProductsReady();
        }
      });
      document.addEventListener("rebuy.loaded", (event) => {
        const widget = event.detail?.widget;
        if (widget && !isConfiguredUpsellWidget(widget)) return;
        onRebuyProductsReady();
      });
      document.addEventListener("rebuy:cart.change", () => {
        scheduleCartRefreshFromRebuy();
        if (syncRebuyFromWidget()) return;
        if (!findRebuyWidget(REBUY_UPSELL_WIDGET_ID)) {
          clearUpsellRecommendations();
          return;
        }
        scheduleRebuyLoad({ force: false });
      });
    }
  
    function bindAddToCartOpen() {
      let opening = false;
      const onAdded = () => {
        if (opening || shouldSuppressExternalCartRefresh()) return;
        opening = true;
        if (root?.classList.contains("is-open")) {
          state.refreshing = true;
          setRefreshUi();
          void pullCartFromServer(true).finally(() => {
            state.refreshing = false;
            setRefreshUi();
            opening = false;
          });
          return;
        }
        void openCartAndRefresh().finally(() => {
          opening = false;
        });
      };
  
      ["rebuy:cart.add", "cart:added"].forEach((eventName) => {
        document.addEventListener(eventName, onAdded);
      });
  
      const originalFetch = window.fetch.bind(window);
      window.fetch = (...args) => {
        const response = originalFetch(...args);
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
        if (/\/cart\/add(\.js)?/.test(url)) {
          response
            .then((res) => {
              if (res?.ok && !shouldSuppressExternalCartRefresh()) onAdded();
            })
            .catch(() => {});
        }
        return response;
      };
    }
  
    function watchNativeCart() {
      const observer = new MutationObserver(() => {
        hideNativeCart();
        if (document.querySelector(".rebuy-cart.is-visible, #rebuy-cart.is-visible")) {
          closeNativeCart();
        }
        if (root?.classList.contains("is-open")) {
          setMicroAppLayer(true);
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style", "open"],
      });
    }
  
    function bindRootEvents() {
      if (!root || root.dataset.scsCart02EventsBound === "1") return;
      root.dataset.scsCart02EventsBound = "1";
      root.addEventListener("click", async (event) => {
        const actionEl = event.target.closest("[data-action]");
        if (!actionEl) return;
        const action = actionEl.dataset.action;
        if ((shouldShowCartSkeleton() || state.refreshing) && action !== "close-cart" && action !== "overlay-close" && action !== "checkout" && action !== "open-upsell-detail" && action !== "edit-line") return;

        if (action === "close-cart" || action === "overlay-close") return closeCart();
        if (action === "edit-line") {
          event.preventDefault();
          if (window.scs_cart_02_edit_fnc !== true) return;
          const lineKey = actionEl.dataset.lineKey || "";
          const aspect = actionEl.dataset.aspect || "setup";
          if (!lineKey) return;
          const opened = window.SCS_EMPTY_CART_01?.openLineEditor?.({ lineKey, aspect });
          if (!opened) {
            window.dispatchEvent(
              new CustomEvent("scs:cart-line-open-editor", {
                detail: { lineKey, aspect },
              }),
            );
          }
          return;
        }
        if (action === "open-upsell-detail") {
          event.preventDefault();
          const variantId = actionEl.dataset.variantId || "";
          const opened = window.SCS_EMPTY_CART_01?.openUpsellDetail?.(variantId);
          if (!opened && variantId) {
            window.dispatchEvent(
              new CustomEvent("scs:cart-upsell-open-detail", {
                detail: { id: variantId, variantId },
              }),
            );
          }
          return;
        }
        if (action === "qty-down" || action === "qty-up" || action === "remove-line") {
          const line = Number(actionEl.dataset.line || 0);
          const item = state.cart?.items?.[line - 1];
          if (!item || isGiftItem(item) || actionEl.disabled) return;
          if (isPremiumCartUpsellLine(item) || hasPremiumWidgetId(item)) {
            if (action === "qty-up") {
              return addExtraPremiumUpsell(item, actionEl);
            }
            const qty =
              action === "remove-line" ? 0 : Math.max(0, item.quantity - 1);
            return changePremiumUpsellLine(item, qty, actionEl);
          }
          const qty = action === "remove-line" ? 0 : action === "qty-down" ? Math.max(0, item.quantity - 1) : item.quantity + 1;
          return changeLine(line, qty, actionEl);
        }
        if (action === "set-upsell-fit") {
          event.preventDefault();
          applyUpsellFit(actionEl.dataset.upsellId, actionEl.dataset.fit || "car");
          return;
        }
        if (action === "upsell-prev") return scrollUpsellCarousel(-1);
        if (action === "upsell-next") return scrollUpsellCarousel(1);
        if (action === "add-upsell") {
          setUpsellLoading(actionEl, true);
          try {
            const upsellId = actionEl.dataset.upsellId;
            const item = state.recommendations.find((rec) => rec.uid === upsellId);
            const variantId = item ? getUpsellPricing(item).variantId : actionEl.dataset.variantId;
            const widgetId = item ? getUpsellAddWidgetId(item) : REBUY_UPSELL_WIDGET_ID;
            await addVariant(variantId, 1, widgetId);
          } finally {
            setUpsellLoading(actionEl, false);
          }
          return;
        }
        if (action === "checkout") {
          if (actionEl.disabled) return;
          window.location.href = "/checkout";
          return;
        }
      });
    }
  
    function boot() {
      if (window.__SCS_CART_02_INITIALIZED__ && document.getElementById(ROOT_ID)) return;
      if (!document.body) return;
  
      try {
      root = ensureMount();
      if (!root) return;
  
      refs = {
        title: document.getElementById("SCS_CART_02_title"),
        body: document.getElementById("SCS_CART_02_body"),
        footer: document.getElementById("SCS_CART_02_footer"),
      };
  
      bindRootEvents();
      applyAugustOfferUpsellHide();
      closeCart();
      bindGlobalCartTriggers();
      hijackNativeCartDrawer();
      hijackRebuySmartCart();
      bindAddToCartOpen();
      bindRebuyEvents();
      prefetchRebuy();
      hideNativeCart();
      watchNativeCart();
      watchBodyOverflowTrap();
      fetchCart({ silent: false });
  
      window.__SCS_CART_02_INITIALIZED__ = true;
      window.SCS_CART_02 = {
        open: openCartAndRefresh,
        close: closeCart,
        refreshSilent: refreshCartSilent,
        applySilent: applyCartSilent,
        holdRefresh,
        isBusy: isCartBusy,
      };
      setTimeout(() => {
        bootstrapping = false;
      }, 1500);
      } catch (err) {
        console.error("[SCS_CART_02] boot failed:", err);
      }
    }
  
    function onReady(fn) {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", fn, { once: true });
        return;
      }
      fn();
    }
  
    onReady(() => {
      if (window.EV_CART_02_DRAWER) boot();
    });
  })();
  